define("discourse/plugins/discourse-data-explorer/admin/adapters/query", ["exports", "admin/adapters/build-plugin"], function (_exports, _buildPlugin) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = (0, _buildPlugin.default)("explorer").extend({});

  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/components/data-explorer-bar-chart", ["exports", "@ember/component", "discourse/lib/load-script", "discourse-common/utils/decorators", "../lib/themeColor"], function (_exports, _component, _loadScript, _decorators, _themeColor) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _component.default.extend((_dec = (0, _decorators.default)("data", "options"), _dec2 = (0, _decorators.default)("labels.[]", "values.[]", "datasetName"), (_obj = {
    barsColor: (0, _themeColor.default)("--tertiary"),
    barsHoverColor: (0, _themeColor.default)("--tertiary-high"),
    gridColor: (0, _themeColor.default)("--primary-low"),
    labelsColor: (0, _themeColor.default)("--primary-medium"),
    chart: null,
    config: function config(data, options) {
      return {
        type: "bar",
        data: data,
        options: options
      };
    },
    data: function data(labels, values, datasetName) {
      return {
        labels: labels,
        datasets: [{
          label: datasetName,
          data: values,
          backgroundColor: this.barsColor,
          hoverBackgroundColor: this.barsHoverColor
        }]
      };
    },
    options: function options() {
      return {
        scales: {
          legend: {
            labels: {
              fontColor: this.labelsColor
            }
          },
          xAxes: [{
            gridLines: {
              color: this.gridColor,
              zeroLineColor: this.gridColor
            },
            ticks: {
              fontColor: this.labelsColor
            }
          }],
          yAxes: [{
            gridLines: {
              color: this.gridColor,
              zeroLineColor: this.gridColor
            },
            ticks: {
              beginAtZero: true,
              fontColor: this.labelsColor
            }
          }]
        }
      };
    },
    didInsertElement: function didInsertElement() {
      this._super.apply(this, arguments);

      this._initChart();
    },
    didUpdate: function didUpdate() {
      this._super.apply(this, arguments);

      this.chart.data = this.data;
      this.chart.update();
    },
    willDestroyElement: function willDestroyElement() {
      this._super.apply(this, arguments);

      this.chart.destroy();
    },
    _initChart: function _initChart() {
      var _this = this;

      (0, _loadScript.default)("/javascripts/Chart.min.js").then(function () {
        var canvas = _this.element.querySelector("canvas");

        var context = canvas.getContext("2d");
        var config = _this.config; // eslint-disable-next-line

        _this.chart = new Chart(context, config);
      });
    }
  }, (_applyDecoratedDescriptor(_obj, "config", [_dec], Object.getOwnPropertyDescriptor(_obj, "config"), _obj), _applyDecoratedDescriptor(_obj, "data", [_dec2], Object.getOwnPropertyDescriptor(_obj, "data"), _obj), _applyDecoratedDescriptor(_obj, "options", [_decorators.default], Object.getOwnPropertyDescriptor(_obj, "options"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/components/explorer-container", ["exports", "@ember/component", "discourse-common/utils/decorators", "@ember/runloop"], function (_exports, _component, _decorators, _runloop) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _component.default.extend((_dec = (0, _decorators.observes)("hideSchema"), _dec2 = (0, _decorators.observes)("everEditing"), (_obj = {
    _onHideSchema: function _onHideSchema() {
      this.appEvents.trigger("ace:resize");
    },
    _onInsertEditor: function _onInsertEditor() {
      var _this = this;

      (0, _runloop.schedule)("afterRender", this, function () {
        return _this._bindControls();
      });
    },
    _bindControls: function _bindControls() {
      var _this2 = this;

      if (this._state !== "inDOM") {
        return;
      }

      var $editPane = $(".query-editor");

      if (!$editPane.length) {
        return;
      }

      var oldGrippie = this.grippie;

      if (oldGrippie) {
        oldGrippie.off("mousedown mousemove mouseup");
      }

      var $grippie = $editPane.find(".grippie");
      var $target = $editPane.find(".panels-flex");
      var $document = $(document);
      var minWidth = $target.width();
      var minHeight = $target.height();
      this.set("grippie", $grippie);

      var mousemove = function mousemove(e) {
        var diffY = _this2.startY - e.screenY;
        var diffX = _this2.startX - e.screenX;
        var newHeight = Math.max(minHeight, _this2.startHeight - diffY);
        var newWidth = Math.max(minWidth, _this2.startWidth - diffX);
        $target.height(newHeight);
        $target.width(newWidth);
        $grippie.width(newWidth);

        _this2.appEvents.trigger("ace:resize");
      };

      var throttledMousemove = function (event) {
        event.preventDefault();
        (0, _runloop.throttle)(_this2, mousemove, event, 20);
      }.bind(this);

      var mouseup = function () {
        $document.off("mousemove", throttledMousemove);
        $document.off("mouseup", mouseup);

        _this2.setProperties({
          startY: null,
          startX: null,
          startHeight: null,
          startWidth: null
        });
      }.bind(this);

      $grippie.on("mousedown", function (e) {
        _this2.setProperties({
          startY: e.screenY,
          startX: e.screenX,
          startHeight: $target.height(),
          startWidth: $target.width()
        });

        $document.on("mousemove", throttledMousemove);
        $document.on("mouseup", mouseup);
        e.preventDefault();
      });
    },
    didInsertElement: function didInsertElement() {
      this._super.apply(this, arguments);

      this._bindControls();
    },
    willDestroyElement: function willDestroyElement() {
      this._super.apply(this, arguments);

      if (this.everEditing) {
        this.grippie && this.grippie.off("mousedown");
        this.set("grippie", null);
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "_onHideSchema", [_dec], Object.getOwnPropertyDescriptor(_obj, "_onHideSchema"), _obj), _applyDecoratedDescriptor(_obj, "_onInsertEditor", [_dec2], Object.getOwnPropertyDescriptor(_obj, "_onInsertEditor"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/components/explorer-schema-enuminfo", ["exports", "@ember/component", "discourse-common/utils/decorators"], function (_exports, _component, _decorators) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _component.default.extend((_dec = (0, _decorators.default)("col.enum"), (_obj = {
    tagName: "ol",
    enuminfo: function enuminfo(hash) {
      var result = [];

      for (var key in hash) {
        if (!hash.hasOwnProperty(key)) {
          continue;
        }

        result.push({
          value: key,
          name: hash[key]
        });
      }

      return result;
    }
  }, (_applyDecoratedDescriptor(_obj, "enuminfo", [_dec], Object.getOwnPropertyDescriptor(_obj, "enuminfo"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/components/explorer-schema-onetable", ["exports", "@ember/component", "discourse-common/utils/decorators", "@ember/object/computed"], function (_exports, _component, _decorators, _computed) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _component.default.extend((_dec = (0, _decorators.on)("didInsertElement"), _dec2 = (0, _decorators.on)("willDestroyElement"), (_obj = {
    classNameBindings: [":schema-table", "open"],
    tagName: "li",
    open: (0, _computed.reads)("table.open"),
    _bindClicks: function _bindClicks() {
      var _this = this;

      $(this.element).find(".schema-table-name").click(function (e) {
        _this.set("table.open", !_this.table.open);

        e.preventDefault();
      });
    },
    _cleanup: function _cleanup() {
      $(this.element).find(".schema-table-name").off("click");
    }
  }, (_applyDecoratedDescriptor(_obj, "_bindClicks", [_dec], Object.getOwnPropertyDescriptor(_obj, "_bindClicks"), _obj), _applyDecoratedDescriptor(_obj, "_cleanup", [_dec2], Object.getOwnPropertyDescriptor(_obj, "_cleanup"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/components/explorer-schema", ["exports", "@ember/component", "discourse-common/utils/decorators", "discourse-common/lib/debounce", "@ember/utils"], function (_exports, _component, _decorators, _debounce, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _component.default.extend((_dec = (0, _decorators.default)("schema"), _dec2 = (0, _decorators.default)("filter"), _dec3 = (0, _decorators.observes)("filter"), _dec4 = (0, _decorators.observes)("filter"), (_obj = {
    actions: {
      collapseSchema: function collapseSchema() {
        this.set("hideSchema", true);
      }
    },
    transformedSchema: function transformedSchema(schema) {
      for (var key in schema) {
        if (!schema.hasOwnProperty(key)) {
          continue;
        }

        schema[key].forEach(function (col) {
          var notes_components = [];

          if (col.primary) {
            notes_components.push("primary key");
          }

          if (col.is_nullable) {
            notes_components.push("null");
          }

          if (col.column_default) {
            notes_components.push("default " + col.column_default);
          }

          if (col.fkey_info) {
            notes_components.push("fkey " + col.fkey_info);
          }

          if (col.denormal) {
            notes_components.push("denormal " + col.denormal);
          }

          var notes = notes_components.join(", ");

          if (notes) {
            col.notes = notes;
          }

          if (col.enum || col.column_desc) {
            col.havepopup = true;
          }

          col.havetypeinfo = !!(col.notes || col.enum || col.column_desc);
        });
      }

      return schema;
    },
    rfilter: function rfilter(filter) {
      if (!(0, _utils.isBlank)(filter)) {
        return new RegExp(filter);
      }
    },
    filterTables: function filterTables(schema) {
      var tables = [];
      var filter = this.rfilter,
          haveFilter = !!filter;

      for (var key in schema) {
        if (!schema.hasOwnProperty(key)) {
          continue;
        }

        if (!haveFilter) {
          tables.push({
            name: key,
            columns: schema[key],
            open: false
          });
          continue;
        } // Check the table name vs the filter


        if (filter.source === key || filter.source + "s" === key) {
          tables.unshift({
            name: key,
            columns: schema[key],
            open: haveFilter
          });
        } else if (filter.test(key)) {
          // whole table matches
          tables.push({
            name: key,
            columns: schema[key],
            open: haveFilter
          });
        } else {
          (function () {
            // filter the columns
            var filterCols = [];
            schema[key].forEach(function (col) {
              if (filter.source === col.column_name) {
                filterCols.unshift(col);
              } else if (filter.test(col.column_name)) {
                filterCols.push(col);
              }
            });

            if (!(0, _utils.isEmpty)(filterCols)) {
              tables.push({
                name: key,
                columns: filterCols,
                open: haveFilter
              });
            }
          })();
        }
      }

      return tables;
    },
    triggerFilter: function triggerFilter() {
      (0, _debounce.default)(this, function () {
        this.set("filteredTables", this.filterTables(this.transformedSchema));
        this.set("loading", false);
      }, 500);
    },
    setLoading: function setLoading() {
      this.set("loading", true);
    },
    init: function init() {
      this._super.apply(this, arguments);

      this.set("loading", true);
      this.triggerFilter();
    }
  }, (_applyDecoratedDescriptor(_obj, "transformedSchema", [_dec], Object.getOwnPropertyDescriptor(_obj, "transformedSchema"), _obj), _applyDecoratedDescriptor(_obj, "rfilter", [_dec2], Object.getOwnPropertyDescriptor(_obj, "rfilter"), _obj), _applyDecoratedDescriptor(_obj, "triggerFilter", [_dec3], Object.getOwnPropertyDescriptor(_obj, "triggerFilter"), _obj), _applyDecoratedDescriptor(_obj, "setLoading", [_dec4], Object.getOwnPropertyDescriptor(_obj, "setLoading"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/components/param-input", ["exports", "@ember/component", "I18n", "discourse-common/utils/decorators", "discourse/models/category", "@ember/string", "@ember/utils", "@ember/object"], function (_exports, _component, _I18n, _decorators, _category, _string, _utils, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var layoutMap = {
    int: "int",
    bigint: "int",
    boolean: "boolean",
    string: "generic",
    time: "generic",
    date: "generic",
    datetime: "generic",
    double: "string",
    user_id: "user_id",
    post_id: "string",
    topic_id: "generic",
    category_id: "generic",
    group_id: "generic",
    badge_id: "generic",
    int_list: "generic",
    string_list: "generic",
    user_list: "user_list"
  };

  function allowsInputTypeTime() {
    try {
      var inp = document.createElement("input");
      inp.attributes.type = "time";
      inp.attributes.type = "date";
      return true;
    } catch (e) {
      return false;
    }
  }

  var _default = _component.default.extend((_dec = (0, _decorators.default)("value", "info.type", "info.nullable"), _dec2 = (0, _decorators.default)("info.type"), _dec3 = (0, _decorators.default)("layoutType"), (_obj = {
    classNameBindings: ["valid:valid:invalid", ":param"],
    boolTypes: [{
      name: _I18n.default.t("explorer.types.bool.true"),
      id: "Y"
    }, {
      name: _I18n.default.t("explorer.types.bool.false"),
      id: "N"
    }, {
      name: _I18n.default.t("explorer.types.bool.null_"),
      id: "#null"
    }],
    initialValues: null,
    init: function init() {
      this._super.apply(this, arguments);

      if (this.initialValues && this.info.identifier in this.initialValues) {
        this.set("value", this.initialValues[this.info.identifier]);
      }
    },
    value: (0, _object.computed)("params", "info.identifier", {
      get: function get() {
        return this.params[this.get("info.identifier")];
      },
      set: function set(key, value) {
        this.params[this.get("info.identifier")] = value === null || value === void 0 ? void 0 : value.toString();
        return value;
      }
    }),
    valueBool: (0, _object.computed)("params", "info.identifier", {
      get: function get() {
        return this.params[this.get("info.identifier")] !== "false";
      },
      set: function set(key, value) {
        value = !!value;
        this.params[this.get("info.identifier")] = value.toString();
        return value;
      }
    }),
    valid: function valid(value, type, nullable) {
      if ((0, _utils.isEmpty)(value)) {
        return nullable;
      }

      var intVal = parseInt(value, 10);
      var intValid = !isNaN(intVal) && intVal < 2147483648 && intVal > -2147483649;
      var isPositiveInt = /^\d+$/.test(value);

      switch (type) {
        case "int":
          return /^-?\d+$/.test(value) && intValid;

        case "bigint":
          return /^-?\d+$/.test(value) && !isNaN(intVal);

        case "boolean":
          return /^Y|N|#null|true|false/.test(value);

        case "double":
          return !isNaN(parseFloat(value)) || /^(-?)Inf(inity)?$/i.test(value) || /^(-?)NaN$/i.test(value);

        case "int_list":
          return value.split(",").every(function (i) {
            return /^(-?\d+|null)$/.test(i.trim());
          });

        case "post_id":
          return isPositiveInt || /\d+\/\d+(\?u=.*)?$/.test(value);

        case "category_id":
          if (!isPositiveInt && value !== (0, _string.dasherize)(value)) {
            this.set("value", (0, _string.dasherize)(value));
          }

          if (isPositiveInt) {
            return !!this.site.categories.find(function (c) {
              return c.id === intVal;
            });
          } else if (/\//.test(value)) {
            var match = /(.*)\/(.*)/.exec(value);

            if (!match) {
              return false;
            }

            var result = _category.default.findBySlug((0, _string.dasherize)(match[2]), (0, _string.dasherize)(match[1]));

            return !!result;
          } else {
            return !!_category.default.findBySlug((0, _string.dasherize)(value));
          }

        case "group_id":
          var groups = this.site.get("groups");

          if (isPositiveInt) {
            return !!groups.find(function (g) {
              return g.id === intVal;
            });
          } else {
            return !!groups.find(function (g) {
              return g.name === value;
            });
          }

      }

      return true;
    },
    layoutType: function layoutType(type) {
      if ((type === "time" || type === "date") && !allowsInputTypeTime()) {
        return "string";
      }

      if (layoutMap[type]) {
        return layoutMap[type];
      }

      return "generic";
    },
    layoutName: function layoutName(layoutType) {
      return "admin/components/q-params/".concat(layoutType);
    }
  }, (_applyDecoratedDescriptor(_obj, "valid", [_dec], Object.getOwnPropertyDescriptor(_obj, "valid"), _obj), _applyDecoratedDescriptor(_obj, "layoutType", [_dec2], Object.getOwnPropertyDescriptor(_obj, "layoutType"), _obj), _applyDecoratedDescriptor(_obj, "layoutName", [_dec3], Object.getOwnPropertyDescriptor(_obj, "layoutName"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/components/query-result", ["exports", "@ember/component", "discourse-common/lib/raw-templates", "I18n", "discourse/lib/ajax", "discourse-common/lib/get-url", "discourse/models/badge", "discourse-common/utils/decorators", "@ember/string", "@ember/object/computed", "@ember/runloop"], function (_exports, _component, _rawTemplates, _I18n, _ajax, _getUrl, _badge2, _decorators, _string, _computed, _runloop) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function randomIdShort() {
    return "xxxxxxxx".replace(/[xy]/g, function () {
      /*eslint-disable*/
      return (Math.random() * 16 | 0).toString(16);
      /*eslint-enable*/
    });
  }

  function transformedRelTable(table, modelClass) {
    var result = {};
    table.forEach(function (item) {
      if (modelClass) {
        result[item.id] = modelClass.create(item);
      } else {
        result[item.id] = item;
      }
    });
    return result;
  }

  var QueryResultComponent = _component.default.extend((_dec = (0, _decorators.default)("content.result_count"), _dec2 = (0, _decorators.default)("content.duration"), _dec3 = (0, _decorators.default)("params.[]"), _dec4 = (0, _decorators.default)("content", "columns.[]"), _dec5 = (0, _decorators.default)("content", "columns.[]"), _dec6 = (0, _decorators.default)("content.relations.user"), _dec7 = (0, _decorators.default)("content.relations.badge"), _dec8 = (0, _decorators.default)("content.relations.post"), _dec9 = (0, _decorators.default)("content.relations.topic"), _dec10 = (0, _decorators.default)("site.groups"), _dec11 = (0, _decorators.default)("rows.[]", "content.colrender.[]", "content.result_count", "colCount"), _dec12 = (0, _decorators.default)("content.rows.[]", "content.colrender.[]"), (_obj = {
    layoutName: "explorer-query-result",
    rows: (0, _computed.alias)("content.rows"),
    columns: (0, _computed.alias)("content.columns"),
    params: (0, _computed.alias)("content.params"),
    explainText: (0, _computed.alias)("content.explain"),
    hasExplain: (0, _computed.notEmpty)("content.explain"),
    chartDatasetName: (0, _computed.reads)("columnDispNames.1"),
    chartValues: (0, _computed.mapBy)("content.rows", "1"),
    showChart: false,
    resultCount: function resultCount(count) {
      if (count === this.get("content.default_limit")) {
        return _I18n.default.t("explorer.max_result_count", {
          count: count
        });
      } else {
        return _I18n.default.t("explorer.result_count", {
          count: count
        });
      }
    },
    colCount: (0, _computed.reads)("content.columns.length"),
    duration: function duration(contentDuration) {
      return _I18n.default.t("explorer.run_time", {
        value: _I18n.default.toNumber(contentDuration, {
          precision: 1
        })
      });
    },
    parameterAry: function parameterAry(params) {
      var arr = [];

      for (var key in params) {
        if (params.hasOwnProperty(key)) {
          arr.push({
            key: key,
            value: params[key]
          });
        }
      }

      return arr;
    },
    columnDispNames: function columnDispNames(content, columns) {
      if (!columns) {
        return [];
      }

      return columns.map(function (colName) {
        if (colName.endsWith("_id")) {
          return colName.slice(0, -3);
        }

        var dIdx = colName.indexOf("$");

        if (dIdx >= 0) {
          return colName.substring(dIdx + 1);
        }

        return colName;
      });
    },
    fallbackTemplate: function fallbackTemplate() {
      return (0, _rawTemplates.findRawTemplate)("javascripts/explorer/text");
    },
    columnTemplates: function columnTemplates(content, columns) {
      var _this = this;

      if (!columns) {
        return [];
      }

      return columns.map(function (colName, idx) {
        var viewName = "text";

        if (_this.get("content.colrender")[idx]) {
          viewName = _this.get("content.colrender")[idx];
        }

        var template = (0, _rawTemplates.findRawTemplate)("javascripts/explorer/".concat(viewName));
        return {
          name: viewName,
          template: template
        };
      });
    },
    transformedUserTable: function transformedUserTable(contentRelationsUser) {
      return transformedRelTable(contentRelationsUser);
    },
    transformedBadgeTable: function transformedBadgeTable(contentRelationsBadge) {
      return transformedRelTable(contentRelationsBadge, _badge2.default);
    },
    transformedPostTable: function transformedPostTable(contentRelationsPost) {
      return transformedRelTable(contentRelationsPost);
    },
    transformedTopicTable: function transformedTopicTable(contentRelationsTopic) {
      return transformedRelTable(contentRelationsTopic);
    },
    transformedGroupTable: function transformedGroupTable(groups) {
      return transformedRelTable(groups);
    },
    canShowChart: function canShowChart(rows, colRender, resultCount, colCount) {
      var hasTwoColumns = colCount === 2;
      var secondColumnContainsNumber = resultCount > 0 && typeof rows[0][1] === "number";
      var secondColumnContainsId = colRender[1];
      return hasTwoColumns && secondColumnContainsNumber && !secondColumnContainsId;
    },
    chartLabels: function chartLabels(rows, colRender) {
      var _this2 = this;

      var labelSelectors = {
        user: function user(_user) {
          return _user.username;
        },
        badge: function badge(_badge) {
          return _badge.name;
        },
        topic: function topic(_topic) {
          return _topic.title;
        },
        group: function group(_group) {
          return _group.name;
        },
        category: function category(_category) {
          return _category.name;
        }
      };
      var relationName = colRender[0];

      if (relationName) {
        var lookupFunc = this["lookup".concat((0, _string.capitalize)(relationName))];
        var labelSelector = labelSelectors[relationName];

        if (lookupFunc && labelSelector) {
          return rows.map(function (r) {
            var relation = lookupFunc.call(_this2, r[0]);
            var label = labelSelector(relation);
            return _this2._cutChartLabel(label);
          });
        }
      }

      return rows.map(function (r) {
        return _this2._cutChartLabel(r[0]);
      });
    },
    lookupUser: function lookupUser(id) {
      return this.transformedUserTable[id];
    },
    lookupBadge: function lookupBadge(id) {
      return this.transformedBadgeTable[id];
    },
    lookupPost: function lookupPost(id) {
      return this.transformedPostTable[id];
    },
    lookupTopic: function lookupTopic(id) {
      return this.transformedTopicTable[id];
    },
    lookupGroup: function lookupGroup(id) {
      return this.transformedGroupTable[id];
    },
    lookupCategory: function lookupCategory(id) {
      return this.site.get("categoriesById")[id];
    },
    download_url: function download_url() {
      return this.group ? "/g/".concat(this.group.name, "/reports/") : "/admin/plugins/explorer/queries/";
    },
    downloadResult: function downloadResult(format) {
      // Create a frame to submit the form in (?)
      // to avoid leaving an about:blank behind
      var windowName = randomIdShort();
      var newWindowContents = "<style>body{font-size:36px;display:flex;justify-content:center;align-items:center;}</style><body>Click anywhere to close this window once the download finishes.<script>window.onclick=function(){window.close()};</script>";
      window.open("data:text/html;base64," + btoa(newWindowContents), windowName);
      var form = document.createElement("form");
      form.setAttribute("id", "query-download-result");
      form.setAttribute("method", "post");
      form.setAttribute("action", (0, _getUrl.default)(this.download_url() + this.get("query.id") + "/run." + format + "?download=1"));
      form.setAttribute("target", windowName);
      form.setAttribute("style", "display:none;");

      function addInput(name, value) {
        var field;
        field = document.createElement("input");
        field.setAttribute("name", name);
        field.setAttribute("value", value);
        form.appendChild(field);
      }

      addInput("params", JSON.stringify(this.params));
      addInput("explain", this.hasExplain);
      addInput("limit", "1000000");
      (0, _ajax.ajax)("/session/csrf.json").then(function (csrf) {
        addInput("authenticity_token", csrf.csrf);
        document.body.appendChild(form);
        form.submit();
        (0, _runloop.schedule)("afterRender", function () {
          return document.body.removeChild(form);
        });
      });
    },
    _cutChartLabel: function _cutChartLabel(label) {
      var labelString = label.toString();

      if (labelString.length > 25) {
        return "".concat(labelString.substring(0, 25), "...");
      } else {
        return labelString;
      }
    },
    actions: {
      downloadResultJson: function downloadResultJson() {
        this.downloadResult("json");
      },
      downloadResultCsv: function downloadResultCsv() {
        this.downloadResult("csv");
      },
      showChart: function showChart() {
        this.set("showChart", true);
      },
      showTable: function showTable() {
        this.set("showChart", false);
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "resultCount", [_dec], Object.getOwnPropertyDescriptor(_obj, "resultCount"), _obj), _applyDecoratedDescriptor(_obj, "duration", [_dec2], Object.getOwnPropertyDescriptor(_obj, "duration"), _obj), _applyDecoratedDescriptor(_obj, "parameterAry", [_dec3], Object.getOwnPropertyDescriptor(_obj, "parameterAry"), _obj), _applyDecoratedDescriptor(_obj, "columnDispNames", [_dec4], Object.getOwnPropertyDescriptor(_obj, "columnDispNames"), _obj), _applyDecoratedDescriptor(_obj, "fallbackTemplate", [_decorators.default], Object.getOwnPropertyDescriptor(_obj, "fallbackTemplate"), _obj), _applyDecoratedDescriptor(_obj, "columnTemplates", [_dec5], Object.getOwnPropertyDescriptor(_obj, "columnTemplates"), _obj), _applyDecoratedDescriptor(_obj, "transformedUserTable", [_dec6], Object.getOwnPropertyDescriptor(_obj, "transformedUserTable"), _obj), _applyDecoratedDescriptor(_obj, "transformedBadgeTable", [_dec7], Object.getOwnPropertyDescriptor(_obj, "transformedBadgeTable"), _obj), _applyDecoratedDescriptor(_obj, "transformedPostTable", [_dec8], Object.getOwnPropertyDescriptor(_obj, "transformedPostTable"), _obj), _applyDecoratedDescriptor(_obj, "transformedTopicTable", [_dec9], Object.getOwnPropertyDescriptor(_obj, "transformedTopicTable"), _obj), _applyDecoratedDescriptor(_obj, "transformedGroupTable", [_dec10], Object.getOwnPropertyDescriptor(_obj, "transformedGroupTable"), _obj), _applyDecoratedDescriptor(_obj, "canShowChart", [_dec11], Object.getOwnPropertyDescriptor(_obj, "canShowChart"), _obj), _applyDecoratedDescriptor(_obj, "chartLabels", [_dec12], Object.getOwnPropertyDescriptor(_obj, "chartLabels"), _obj)), _obj)));

  var _default = QueryResultComponent;
  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/components/query-row-content", ["exports", "@ember/component", "discourse/helpers/category-link", "discourse/lib/formatter", "discourse-common/lib/icon-library", "discourse-common/lib/get-url", "@ember/string", "@ember/template", "@ember/object", "@ember/utils", "discourse/lib/utilities"], function (_exports, _component, _categoryLink, _formatter, _iconLibrary, _getUrl, _string, _template, _object, _utils, _utilities) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

  function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

  function icon_or_image_replacement(str, ctx) {
    str = (0, _object.get)(ctx.contexts[0], str);

    if ((0, _utils.isEmpty)(str)) {
      return "";
    }

    if (str.indexOf("fa-") > -1) {
      var icon = (0, _iconLibrary.iconHTML)((0, _iconLibrary.convertIconClass)(str));
      return (0, _template.htmlSafe)(icon);
    } else {
      return (0, _template.htmlSafe)("<img src='" + str + "'>");
    }
  }

  function category_badge_replacement(str, ctx) {
    var category = (0, _object.get)(ctx.contexts[0], str);
    return (0, _categoryLink.categoryLinkHTML)(category, {
      allowUncategorized: true
    });
  }

  function bound_date_replacement(str, ctx) {
    var value = (0, _object.get)(ctx.contexts[0], str);
    return (0, _template.htmlSafe)((0, _formatter.autoUpdatingRelativeAge)(new Date(value), {
      title: true
    }));
  } // consider moving this elsewhere


  function guessUrl(t) {
    var dest = t,
        name = t;
    var split = t.split(/,(.+)/);

    if (split.length > 1) {
      name = split[0];
      dest = split[1];
    }

    return [dest, name];
  }

  var QueryRowContentComponent = _component.default.extend({
    tagName: "tr",
    rowContents: null,
    didReceiveAttrs: function didReceiveAttrs() {
      var row = this.row;
      var parentView = this.parentView;
      var fallback = this.fallbackTemplate;
      var helpers = {
        "icon-or-image": icon_or_image_replacement,
        "category-link": category_badge_replacement,
        reltime: bound_date_replacement
      };
      var parts = this.columnTemplates.map(function (t, idx) {
        var value = row[idx],
            id = parseInt(value, 10);
        var ctx = {
          value: value,
          id: id,
          baseuri: (0, _getUrl.default)("")
        };
        var params = {};

        if (row[idx] === null) {
          return "NULL";
        } else if (t.name === "text") {
          return (0, _utilities.escapeExpression)(row[idx]);
        }

        var lookupFunc = parentView["lookup".concat((0, _string.capitalize)(t.name))];

        if (lookupFunc) {
          ctx[t.name] = lookupFunc.call(parentView, id);
        }

        if (t.name === "url") {
          var _guessUrl = guessUrl(value),
              _guessUrl2 = _slicedToArray(_guessUrl, 2),
              url = _guessUrl2[0],
              name = _guessUrl2[1];

          ctx["href"] = url;
          ctx["target"] = name;
        }

        if (t.name === "category" || t.name === "badge" || t.name === "reltime") {
          // only replace helpers if needed
          params.helpers = helpers;
        }

        try {
          return (0, _template.htmlSafe)((t.template || fallback)(ctx, params));
        } catch (e) {
          return "error";
        }
      });
      this.set("rowContents", (0, _template.htmlSafe)("<td>".concat(parts.join("</td><td>"), "</td>")));
    }
  });

  var _default = QueryRowContentComponent;
  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/components/share-report", ["exports", "@ember/component", "discourse-common/utils/decorators", "discourse-common/lib/get-url", "@ember/runloop"], function (_exports, _component, _decorators, _getUrl, _runloop) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _component.default.extend((_dec = (0, _decorators.default)("group", "query"), _dec2 = (0, _decorators.on)("init"), (_obj = {
    classNames: ["share-report"],
    group: null,
    query: null,
    visible: false,
    link: function link() {
      return (0, _getUrl.default)("/g/".concat(this.group, "/reports/").concat(this.query.id));
    },
    _mouseDownHandler: function _mouseDownHandler(event) {
      if (!this.element || this.isDestroying || this.isDestroyed) {
        return;
      }

      if ($(this.element).has(event.target).length !== 0) {
        return;
      }

      this.send("close");
      return true;
    },
    _keydownHandler: function _keydownHandler(event) {
      if (!this.element || this.isDestroying || this.isDestroyed) {
        return;
      }

      if (event.keyCode === 27) {
        this.send("close");
      }
    },
    _setupHandlers: function _setupHandlers() {
      this._boundMouseDownHandler = (0, _runloop.bind)(this, this._mouseDownHandler);
      this._boundKeydownHandler = (0, _runloop.bind)(this, this._keydownHandler);
    },
    didInsertElement: function didInsertElement() {
      this._super.apply(this, arguments);

      $("html").on("mousedown.outside-share-link", this._boundMouseDownHandler).on("keydown.share-view", this._boundKeydownHandler);
    },
    willDestroyElement: function willDestroyElement() {
      this._super.apply(this, arguments);

      $("html").off("mousedown.outside-share-link", this._boundMouseDownHandler).off("keydown.share-view", this._boundKeydownHandler);
    },
    actions: {
      open: function open() {
        var _this = this;

        this.set("visible", true);
        window.setTimeout(function () {
          return $(_this.element).find("input").select().focus();
        }, 160);
      },
      close: function close() {
        this.set("visible", false);
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "link", [_dec], Object.getOwnPropertyDescriptor(_obj, "link"), _obj), _applyDecoratedDescriptor(_obj, "_setupHandlers", [_dec2], Object.getOwnPropertyDescriptor(_obj, "_setupHandlers"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/connectors/group-reports-nav-item/nav-item", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    shouldRender: function shouldRender(args) {
      return args.group.has_visible_data_explorer_queries;
    }
  };
  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/controllers/admin-plugins-explorer", ["exports", "@ember/controller", "discourse/lib/show-modal", "discourse/plugins/discourse-data-explorer/discourse/models/query", "discourse/lib/ajax-error", "discourse/lib/ajax", "discourse-common/utils/decorators", "I18n", "rsvp", "bootbox", "@ember/object", "@ember/object/computed"], function (_exports, _controller, _showModal, _query, _ajaxError, _ajax, _decorators, _I18n, _rsvp, _bootbox, _object, _computed) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _obj;

  function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return !!right[Symbol.hasInstance](left); } else { return left instanceof right; } }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var NoQuery = _query.default.create({
    name: "No queries",
    fake: true,
    group_ids: []
  });

  var _default = _controller.default.extend((_dec = (0, _decorators.default)("params"), _dec2 = (0, _decorators.default)("search", "sortBy"), _dec3 = (0, _decorators.default)("newQueryName"), _dec4 = (0, _decorators.default)("selectedQueryId"), _dec5 = (0, _decorators.default)("selectedItem", "editing"), _dec6 = (0, _decorators.default)("groups"), _dec7 = (0, _decorators.default)("selectedItem", "selectedItem.dirty"), _dec8 = (0, _decorators.observes)("editing"), (_obj = {
    queryParams: {
      selectedQueryId: "id",
      params: "params"
    },
    selectedQueryId: null,
    editDisabled: false,
    showResults: false,
    hideSchema: false,
    loading: false,
    explain: false,
    saveDisabled: (0, _computed.not)("selectedItem.dirty"),
    runDisabled: (0, _computed.reads)("selectedItem.dirty"),
    results: (0, _computed.reads)("selectedItem.results"),
    asc: null,
    order: null,
    editing: false,
    everEditing: false,
    showRecentQueries: true,
    sortBy: ["last_run_at:desc"],
    sortedQueries: (0, _computed.sort)("model", "sortBy"),
    parsedParams: function parsedParams(params) {
      return params ? JSON.parse(params) : null;
    },
    acceptedImportFileTypes: function acceptedImportFileTypes() {
      return ["application/json"];
    },
    filteredContent: function filteredContent(search) {
      var regexp = new RegExp(search, "i");
      return this.sortedQueries.filter(function (result) {
        return regexp.test(result.name) || regexp.test(result.description);
      });
    },
    createDisabled: function createDisabled(newQueryName) {
      return (newQueryName || "").trim().length === 0;
    },
    selectedItem: function selectedItem(selectedQueryId) {
      var id = parseInt(selectedQueryId, 10);
      var item = this.model.findBy("id", id);
      !isNaN(id) ? this.set("showRecentQueries", false) : this.set("showRecentQueries", true);

      if (id < 0) {
        this.set("editDisabled", true);
      }

      return item || NoQuery;
    },
    selectedGroupNames: function selectedGroupNames() {
      var _this = this;

      var groupIds = this.selectedItem.group_ids || [];
      var groupNames = groupIds.map(function (id) {
        return _this.groupOptions.find(function (groupOption) {
          return groupOption.id === id;
        }).name;
      });
      return groupNames.join(", ");
    },
    groupOptions: function groupOptions(groups) {
      return groups.filter(function (g) {
        return g.id !== 0;
      }).map(function (g) {
        return {
          id: g.id,
          name: g.name
        };
      });
    },
    othersDirty: function othersDirty(selectedItem) {
      return !!this.model.find(function (q) {
        return q !== selectedItem && q.dirty;
      });
    },
    setEverEditing: function setEverEditing() {
      if (this.editing && !this.everEditing) {
        this.set("everEditing", true);
      }
    },
    addCreatedRecord: function addCreatedRecord(record) {
      this.model.pushObject(record);
      this.set("selectedQueryId", (0, _object.get)(record, "id"));
      this.selectedItem.set("dirty", false);
      this.setProperties({
        showResults: false,
        results: null,
        editing: true
      });
    },
    save: function save() {
      var _this2 = this;

      this.set("loading", true);

      if (this.get("selectedItem.description") === "") {
        this.set("selectedItem.description", "");
      }

      return this.selectedItem.save().then(function () {
        var query = _this2.selectedItem;
        query.markNotDirty();

        _this2.set("editing", false);
      }).catch(function (x) {
        (0, _ajaxError.popupAjaxError)(x);
        throw x;
      }).finally(function () {
        return _this2.set("loading", false);
      });
    },
    _importQuery: async function _importQuery(file) {
      var json = await this._readFileAsTextAsync(file);

      var query = this._parseQuery(json);

      var record = this.store.createRecord("query", query);
      var response = await record.save();
      return response.target;
    },
    _parseQuery: function _parseQuery(json) {
      var parsed = JSON.parse(json);
      var query = parsed.query;

      if (!query || !query.sql) {
        throw new TypeError();
      }

      query.id = 0; // 0 means no Id yet

      return query;
    },
    _readFileAsTextAsync: function _readFileAsTextAsync(file) {
      return new _rsvp.Promise(function (resolve, reject) {
        var reader = new FileReader();

        reader.onload = function () {
          resolve(reader.result);
        };

        reader.onerror = reject;
        reader.readAsText(file);
      });
    },
    actions: {
      dummy: function dummy() {},
      expandSchema: function expandSchema() {
        this.set("hideSchema", false);
      },
      import: function _import(files) {
        var _this3 = this;

        this.set("loading", true);
        var file = files[0];

        this._importQuery(file).then(function (record) {
          return _this3.addCreatedRecord(record);
        }).catch(function (e) {
          if (e.jqXHR) {
            (0, _ajaxError.popupAjaxError)(e);
          } else if (_instanceof(e, SyntaxError)) {
            _bootbox.default.alert(_I18n.default.t("explorer.import.unparseable_json"));
          } else if (_instanceof(e, TypeError)) {
            _bootbox.default.alert(_I18n.default.t("explorer.import.wrong_json"));
          } else {
            _bootbox.default.alert(_I18n.default.t("errors.desc.unknown")); // eslint-disable-next-line no-console


            console.error(e);
          }
        }).finally(function () {
          _this3.set("loading", false);
        });
      },
      showCreate: function showCreate() {
        this.set("showCreate", true);
      },
      editName: function editName() {
        this.set("editing", true);
      },
      download: function download() {
        window.open(this.get("selectedItem.downloadUrl"), "_blank");
      },
      scrollTop: function scrollTop() {
        window.scrollTo(0, 0);
        this.setProperties({
          editing: false,
          everEditing: false
        });
      },
      goHome: function goHome() {
        this.setProperties({
          asc: null,
          order: null,
          showResults: false,
          editDisabled: false,
          showRecentQueries: true,
          selectedQueryId: null,
          params: null,
          sortBy: ["last_run_at:desc"]
        });
        this.transitionToRoute({
          queryParams: {
            id: null,
            params: null
          }
        });
      },
      showHelpModal: function showHelpModal() {
        (0, _showModal.default)("query-help");
      },
      resetParams: function resetParams() {
        this.selectedItem.resetParams();
      },
      saveDefaults: function saveDefaults() {
        this.selectedItem.saveDefaults();
      },
      save: function save() {
        this.save();
      },
      saverun: function saverun() {
        var _this4 = this;

        this.save().then(function () {
          return _this4.send("run");
        });
      },
      sortByProperty: function sortByProperty(property) {
        if (this.sortBy[0] === "".concat(property, ":desc")) {
          this.set("sortBy", ["".concat(property, ":asc")]);
        } else {
          this.set("sortBy", ["".concat(property, ":desc")]);
        }
      },
      create: function create() {
        var _this5 = this;

        var name = this.newQueryName.trim();
        this.setProperties({
          loading: true,
          showCreate: false,
          showRecentQueries: false
        });
        this.store.createRecord("query", {
          name: name
        }).save().then(function (result) {
          return _this5.addCreatedRecord(result.target);
        }).catch(_ajaxError.popupAjaxError).finally(function () {
          return _this5.set("loading", false);
        });
      },
      discard: function discard() {
        var _this6 = this;

        this.set("loading", true);
        this.store.find("query", this.get("selectedItem.id")).then(function (result) {
          var query = _this6.get("selectedItem");

          query.setProperties(result.getProperties(_query.default.updatePropertyNames));

          if (!query.group_ids || !Array.isArray(query.group_ids)) {
            query.set("group_ids", []);
          }

          query.markNotDirty();

          _this6.set("editing", false);
        }).catch(_ajaxError.popupAjaxError).finally(function () {
          return _this6.set("loading", false);
        });
      },
      destroy: function destroy() {
        var _this7 = this;

        var query = this.selectedItem;
        this.setProperties({
          loading: true,
          showResults: false
        });
        this.store.destroyRecord("query", query).then(function () {
          return query.set("destroyed", true);
        }).catch(_ajaxError.popupAjaxError).finally(function () {
          return _this7.set("loading", false);
        });
      },
      recover: function recover() {
        var _this8 = this;

        var query = this.selectedItem;
        this.setProperties({
          loading: true,
          showResults: true
        });
        query.save().then(function () {
          return query.set("destroyed", false);
        }).catch(_ajaxError.popupAjaxError).finally(function () {
          _this8.set("loading", false);
        });
      },
      run: function run() {
        var _this9 = this;

        if (this.get("selectedItem.dirty")) {
          return;
        }

        if (this.runDisabled) {
          return;
        }

        this.setProperties({
          loading: true,
          showResults: false,
          params: JSON.stringify(this.selectedItem.params)
        });
        (0, _ajax.ajax)("/admin/plugins/explorer/queries/" + this.get("selectedItem.id") + "/run", {
          type: "POST",
          data: {
            params: JSON.stringify(this.get("selectedItem.params")),
            explain: this.explain
          }
        }).then(function (result) {
          _this9.set("results", result);

          if (!result.success) {
            _this9.set("showResults", false);

            return;
          }

          _this9.set("showResults", true);
        }).catch(function (err) {
          _this9.set("showResults", false);

          if (err.jqXHR && err.jqXHR.status === 422 && err.jqXHR.responseJSON) {
            _this9.set("results", err.jqXHR.responseJSON);
          } else {
            (0, _ajaxError.popupAjaxError)(err);
          }
        }).finally(function () {
          return _this9.set("loading", false);
        });
      }
    }
  }, (_applyDecoratedDescriptor(_obj, "parsedParams", [_dec], Object.getOwnPropertyDescriptor(_obj, "parsedParams"), _obj), _applyDecoratedDescriptor(_obj, "acceptedImportFileTypes", [_decorators.default], Object.getOwnPropertyDescriptor(_obj, "acceptedImportFileTypes"), _obj), _applyDecoratedDescriptor(_obj, "filteredContent", [_dec2], Object.getOwnPropertyDescriptor(_obj, "filteredContent"), _obj), _applyDecoratedDescriptor(_obj, "createDisabled", [_dec3], Object.getOwnPropertyDescriptor(_obj, "createDisabled"), _obj), _applyDecoratedDescriptor(_obj, "selectedItem", [_dec4], Object.getOwnPropertyDescriptor(_obj, "selectedItem"), _obj), _applyDecoratedDescriptor(_obj, "selectedGroupNames", [_dec5], Object.getOwnPropertyDescriptor(_obj, "selectedGroupNames"), _obj), _applyDecoratedDescriptor(_obj, "groupOptions", [_dec6], Object.getOwnPropertyDescriptor(_obj, "groupOptions"), _obj), _applyDecoratedDescriptor(_obj, "othersDirty", [_dec7], Object.getOwnPropertyDescriptor(_obj, "othersDirty"), _obj), _applyDecoratedDescriptor(_obj, "setEverEditing", [_dec8], Object.getOwnPropertyDescriptor(_obj, "setEverEditing"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/controllers/group-reports-index", ["exports", "@ember/controller", "@ember/object/computed"], function (_exports, _controller, _computed) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _controller.default.extend({
    queries: (0, _computed.alias)("model.queries")
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/controllers/group-reports-show", ["exports", "@ember/controller", "discourse/lib/ajax-error", "discourse/lib/ajax", "discourse/models/bookmark", "discourse/controllers/bookmark", "discourse-common/utils/decorators", "@ember/object/computed"], function (_exports, _controller, _ajaxError, _ajax, _bookmark, _bookmark2, _decorators, _computed) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _controller.default.extend((_dec = (0, _decorators.default)("queryGroup.bookmark"), _dec2 = (0, _decorators.default)("queryGroup.bookmark"), _dec3 = (0, _decorators.default)("queryGroup.bookmark"), (_obj = {
    showResults: false,
    explain: false,
    loading: false,
    results: (0, _computed.alias)("model.results"),
    hasParams: (0, _computed.gt)("model.param_info.length", 0),
    actions: {
      run: function run() {
        var _this = this;

        this.setProperties({
          loading: true,
          showResults: false
        });
        (0, _ajax.ajax)("/g/".concat(this.get("group.name"), "/reports/").concat(this.model.id, "/run"), {
          type: "POST",
          data: {
            params: JSON.stringify(this.model.params),
            explain: this.explain
          }
        }).then(function (result) {
          _this.set("results", result);

          if (!result.success) {
            return;
          }

          _this.set("showResults", true);
        }).catch(function (err) {
          if (err.jqXHR && err.jqXHR.status === 422 && err.jqXHR.responseJSON) {
            _this.set("results", err.jqXHR.responseJSON);
          } else {
            (0, _ajaxError.popupAjaxError)(err);
          }
        }).finally(function () {
          return _this.set("loading", false);
        });
      },
      toggleBookmark: function toggleBookmark() {
        var _this2 = this;

        return (0, _bookmark2.openBookmarkModal)(this.queryGroup.bookmark || _bookmark.default.create({
          bookmarkable_type: "DataExplorer::QueryGroup",
          bookmarkable_id: this.queryGroup.id,
          user_id: this.currentUser.id
        }), {
          onAfterSave: function onAfterSave(savedData) {
            var bookmark = _bookmark.default.create(savedData);

            _this2.set("queryGroup.bookmark", bookmark);

            _this2.appEvents.trigger("bookmarks:changed", savedData, bookmark.attachedTo());
          },
          onAfterDelete: function onAfterDelete() {
            _this2.set("queryGroup.bookmark", null);
          }
        });
      }
    },
    bookmarkLabel: function bookmarkLabel(bookmark) {
      return bookmark ? "bookmarked.edit_bookmark" : "bookmarked.title";
    },
    bookmarkIcon: function bookmarkIcon(bookmark) {
      if (bookmark && bookmark.reminder_at) {
        return _bookmark.WITH_REMINDER_ICON;
      }

      return _bookmark.NO_REMINDER_ICON;
    },
    bookmarkClassName: function bookmarkClassName(bookmark) {
      return bookmark ? ["bookmark", "bookmarked", "query-group-bookmark"].join(" ") : ["bookmark", "query-group-bookmark"].join(" ");
    }
  }, (_applyDecoratedDescriptor(_obj, "bookmarkLabel", [_dec], Object.getOwnPropertyDescriptor(_obj, "bookmarkLabel"), _obj), _applyDecoratedDescriptor(_obj, "bookmarkIcon", [_dec2], Object.getOwnPropertyDescriptor(_obj, "bookmarkIcon"), _obj), _applyDecoratedDescriptor(_obj, "bookmarkClassName", [_dec3], Object.getOwnPropertyDescriptor(_obj, "bookmarkClassName"), _obj)), _obj)));

  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/explorer-route-map", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    resource: "admin.adminPlugins",
    path: "/plugins",
    map: function map() {
      this.route("explorer");
    }
  };
  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/group-reports-route-map", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    resource: "group",
    map: function map() {
      this.route("reports", function () {
        this.route("show", {
          path: "/:query_id"
        });
      });
    }
  };
  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/initializers/initialize-data-explorer", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    name: "initialize-data-explorer",
    initialize: function initialize(container) {
      container.lookup("service:store").addPluralization("query", "queries");
    }
  };
  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/lib/themeColor", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = themeColor;

  function themeColor(name) {
    var style = getComputedStyle(document.body);
    return style.getPropertyValue(name);
  }
});
define("discourse/plugins/discourse-data-explorer/discourse/models/query", ["exports", "discourse-common/utils/decorators", "discourse-common/lib/get-url", "discourse/models/rest", "@ember/object/computed"], function (_exports, _decorators, _getUrl, _rest, _computed) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var Query = _rest.default.extend((_dec = (0, _decorators.on)("init"), _dec2 = (0, _decorators.on)("init"), _dec3 = (0, _decorators.observes)("param_info"), _dec4 = (0, _decorators.observes)("name", "description", "sql", "group_ids"), _dec5 = (0, _decorators.default)("id"), (_obj = {
    dirty: false,
    params: {},
    results: null,
    _init: function _init() {
      this._super.apply(this, arguments);

      this.set("dirty", false);
    },
    _initParams: function _initParams() {
      this.resetParams();
    },
    markDirty: function markDirty() {
      this.set("dirty", true);
    },
    markNotDirty: function markNotDirty() {
      this.set("dirty", false);
    },
    hasParams: (0, _computed.reads)("param_info.length"),
    resetParams: function resetParams() {
      var newParams = {};
      var oldParams = this.params;
      var paramInfo = this.param_info || [];
      paramInfo.forEach(function (pinfo) {
        var name = pinfo.identifier;

        if (oldParams[pinfo.identifier]) {
          newParams[name] = oldParams[name];
        } else if (pinfo["default"] !== null) {
          newParams[name] = pinfo["default"];
        } else if (pinfo["type"] === "boolean") {
          newParams[name] = "false";
        } else if (pinfo["type"] === "user_id") {
          newParams[name] = null;
        } else if (pinfo["type"] === "user_list") {
          newParams[name] = null;
        } else {
          newParams[name] = "";
        }
      });
      this.set("params", newParams);
    },
    downloadUrl: function downloadUrl(id) {
      // TODO - can we change this to use the store/adapter?
      return (0, _getUrl.default)("/admin/plugins/explorer/queries/".concat(id, ".json?export=1"));
    },
    createProperties: function createProperties() {
      if (this.sql) {
        // Importing
        return this.updateProperties();
      }

      return this.getProperties("name");
    },
    updateProperties: function updateProperties() {
      var props = this.getProperties(Query.updatePropertyNames);

      if (this.destroyed) {
        props.id = this.id;
      }

      return props;
    }
  }, (_applyDecoratedDescriptor(_obj, "_init", [_dec], Object.getOwnPropertyDescriptor(_obj, "_init"), _obj), _applyDecoratedDescriptor(_obj, "_initParams", [_dec2, _dec3], Object.getOwnPropertyDescriptor(_obj, "_initParams"), _obj), _applyDecoratedDescriptor(_obj, "markDirty", [_dec4], Object.getOwnPropertyDescriptor(_obj, "markDirty"), _obj), _applyDecoratedDescriptor(_obj, "downloadUrl", [_dec5], Object.getOwnPropertyDescriptor(_obj, "downloadUrl"), _obj)), _obj)));

  Query.reopenClass({
    updatePropertyNames: ["name", "description", "sql", "user_id", "created_at", "group_ids", "last_run_at"]
  });
  var _default = Query;
  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/routes/admin-plugins-explorer", ["exports", "discourse/lib/ajax", "discourse/models/user", "discourse/routes/discourse"], function (_exports, _ajax, _user, _discourse) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _discourse.default.extend({
    controllerName: "admin-plugins-explorer",
    model: function model() {
      if (!_user.default.currentProp("admin")) {
        // display "Only available to admins" message
        return {
          model: null,
          schema: null,
          disallow: true,
          groups: null
        };
      }

      var groupPromise = (0, _ajax.ajax)("/admin/plugins/explorer/groups.json");
      var schemaPromise = (0, _ajax.ajax)("/admin/plugins/explorer/schema.json", {
        cache: true
      });
      var queryPromise = this.store.findAll("query");
      return groupPromise.then(function (groups) {
        var groupNames = {};
        groups.forEach(function (g) {
          groupNames[g.id] = g.name;
        });
        return schemaPromise.then(function (schema) {
          return queryPromise.then(function (model) {
            model.forEach(function (query) {
              query.markNotDirty();
              query.set("group_names", (query.group_ids || []).map(function (id) {
                return groupNames[id];
              }));
            });
            return {
              model: model,
              schema: schema,
              groups: groups
            };
          });
        });
      });
    },
    setupController: function setupController(controller, model) {
      controller.setProperties(model);
    }
  });

  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/routes/group-reports-index", ["exports", "discourse/lib/ajax", "discourse/routes/discourse", "@ember/object"], function (_exports, _ajax, _discourse, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _discourse.default.extend((_obj = {
    controllerName: "group-reports-index",
    model: function model() {
      var _this = this;

      var group = this.modelFor("group");
      return (0, _ajax.ajax)("/g/".concat(group.name, "/reports")).then(function (queries) {
        return {
          model: queries,
          group: group
        };
      }).catch(function () {
        return _this.transitionTo("group.members", group);
      });
    },
    afterModel: function afterModel(model) {
      if (!model.group.get("is_group_user") && !(this.currentUser && this.currentUser.admin)) {
        this.transitionTo("group.members", model.group);
      }
    },
    setupController: function setupController(controller, model) {
      controller.setProperties(model);
    },
    refreshModel: function refreshModel() {
      this.refresh();
      return false;
    }
  }, (_applyDecoratedDescriptor(_obj, "refreshModel", [_object.action], Object.getOwnPropertyDescriptor(_obj, "refreshModel"), _obj)), _obj));

  _exports.default = _default;
});
define("discourse/plugins/discourse-data-explorer/discourse/routes/group-reports-show", ["exports", "discourse/lib/ajax", "discourse/routes/discourse", "@ember/object"], function (_exports, _ajax, _discourse, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _obj;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  var _default = _discourse.default.extend((_obj = {
    controllerName: "group-reports-show",
    model: function model(params) {
      var _this = this;

      var group = this.modelFor("group");
      return (0, _ajax.ajax)("/g/".concat(group.name, "/reports/").concat(params.query_id)).then(function (response) {
        var query = response.query;
        var queryGroup = response.query_group;
        var queryParamInfo = query.param_info;
        var queryParams = queryParamInfo.reduce(function (acc, param) {
          acc[param.identifier] = param.default;
          return acc;
        }, {});
        return {
          model: Object.assign({
            params: queryParams
          }, query),
          group: group,
          queryGroup: queryGroup
        };
      }).catch(function () {
        _this.transitionTo("group.members", group);
      });
    },
    setupController: function setupController(controller, model) {
      controller.setProperties(model);
    },
    refreshModel: function refreshModel() {
      this.refresh();
      return false;
    }
  }, (_applyDecoratedDescriptor(_obj, "refreshModel", [_object.action], Object.getOwnPropertyDescriptor(_obj, "refreshModel"), _obj)), _obj));

  _exports.default = _default;
});
Ember.TEMPLATES["javascripts/admin/components/q-params/boolean"] = Ember.HTMLBars.template({"id":null,"block":"[[[41,[33,1,[\"nullable\"]],[[[1,\"  \"],[1,[28,[35,2],null,[[\"valueAttribute\",\"value\",\"nameProperty\",\"content\"],[\"id\",[33,3],\"name\",[33,4]]]]],[1,\"\\n\"]],[]],[[[1,\"  \"],[1,[28,[35,5],null,[[\"type\",\"checked\"],[\"checkbox\",[33,6]]]]],[1,\"\\n\"]],[]]],[1,\"\\n\"],[10,1],[14,0,\"param-name\"],[12],[1,[33,1,[\"identifier\"]]],[13],[1,\"\\n\"]],[],false,[\"if\",\"info\",\"combo-box\",\"value\",\"boolTypes\",\"input\",\"valueBool\"]]","moduleName":"javascripts/discourse/templates/admin/components/q-params/boolean","isStrictMode":false});
Ember.TEMPLATES["javascripts/admin/components/q-params/generic"] = Ember.HTMLBars.template({"id":null,"block":"[[[1,[28,[35,0],null,[[\"value\"],[[33,1]]]]],[1,\"\\n\"],[10,1],[14,0,\"param-name\"],[12],[1,[33,2,[\"identifier\"]]],[13],[1,\"\\n\"]],[],false,[\"text-field\",\"value\",\"info\"]]","moduleName":"javascripts/discourse/templates/admin/components/q-params/generic","isStrictMode":false});
Ember.TEMPLATES["javascripts/admin/components/q-params/int"] = Ember.HTMLBars.template({"id":null,"block":"[[[1,[28,[35,0],null,[[\"type\",\"value\"],[\"number\",[33,1]]]]],[1,\"\\n\"],[10,1],[14,0,\"param-name\"],[12],[1,[33,2,[\"identifier\"]]],[13],[1,\"\\n\"]],[],false,[\"input\",\"value\",\"info\"]]","moduleName":"javascripts/discourse/templates/admin/components/q-params/int","isStrictMode":false});
Ember.TEMPLATES["javascripts/admin/components/q-params/string"] = Ember.HTMLBars.template({"id":null,"block":"[[[1,[28,[35,0],null,[[\"value\",\"type\"],[[33,1],\"text\"]]]],[1,\"\\n\"],[10,1],[14,0,\"param-name\"],[12],[1,[33,2,[\"identifier\"]]],[13],[1,\"\\n\"]],[],false,[\"text-field\",\"value\",\"info\"]]","moduleName":"javascripts/discourse/templates/admin/components/q-params/string","isStrictMode":false});
Ember.TEMPLATES["javascripts/admin/components/q-params/user_id"] = Ember.HTMLBars.template({"id":null,"block":"[[[1,[28,[35,0],null,[[\"value\",\"options\",\"onChange\"],[[33,1],[28,[37,2],null,[[\"maximum\"],[1]]],[28,[37,3],[[30,0],[28,[37,4],[[33,1]],null]],null]]]]],[1,\"\\n\\n\"],[10,1],[14,0,\"param-name\"],[12],[1,[33,5,[\"identifier\"]]],[13],[1,\"\\n\"]],[],false,[\"email-group-user-chooser\",\"value\",\"hash\",\"action\",\"mut\",\"info\"]]","moduleName":"javascripts/discourse/templates/admin/components/q-params/user_id","isStrictMode":false});
Ember.TEMPLATES["javascripts/admin/components/q-params/user_list"] = Ember.HTMLBars.template({"id":null,"block":"[[[1,[28,[35,0],null,[[\"value\",\"onChange\"],[[33,1],[28,[37,2],[[30,0],[28,[37,3],[[33,1]],null]],null]]]]],[1,\"\\n\"],[10,1],[14,0,\"param-name\"],[12],[1,[33,4,[\"identifier\"]]],[13],[1,\"\\n\"]],[],false,[\"email-group-user-chooser\",\"value\",\"action\",\"mut\",\"info\"]]","moduleName":"javascripts/discourse/templates/admin/components/q-params/user_list","isStrictMode":false});
Ember.TEMPLATES["javascripts/admin/plugins-explorer"] = Ember.HTMLBars.template({"id":null,"block":"[[[6,[39,0],null,[[\"hideSchema\",\"everEditing\"],[[33,1],[33,2]]],[[\"default\"],[[[[41,[33,4],[[[1,\"    \"],[10,\"h1\"],[12],[1,[28,[35,5],[\"explorer.admins_only\"],null]],[13],[1,\"\\n\"]],[]],[[[41,[51,[33,7]],[[[1,\"      \"],[10,0],[14,0,\"query-list\"],[12],[1,\"\\n        \"],[1,[28,[35,8],null,[[\"value\",\"placeholderKey\"],[[33,9],\"explorer.search_placeholder\"]]]],[1,\"\\n        \"],[1,[28,[35,10],null,[[\"action\",\"icon\",\"class\"],[[28,[37,11],[[30,0],\"showCreate\"],null],\"plus\",\"no-text btn-right\"]]]],[1,\"\\n        \"],[1,[28,[35,12],null,[[\"class\",\"label\",\"icon\",\"acceptedFormatsOverride\",\"showButton\",\"onFilesPicked\"],[\"import-btn\",\"explorer.import.label\",\"upload\",[33,13],true,[28,[37,11],[[30,0],\"import\"],null]]]]],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[33,14],[[[1,\"        \"],[10,0],[14,0,\"query-create\"],[12],[1,\"\\n          \"],[1,[28,[35,8],null,[[\"value\",\"placeholderKey\"],[[33,15],\"explorer.create_placeholder\"]]]],[1,\"\\n          \"],[1,[28,[35,10],null,[[\"action\",\"disabled\",\"label\",\"icon\"],[[28,[37,11],[[30,0],\"create\"],null],[33,16],\"explorer.create\",\"plus\"]]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[33,17],[[[1,\"        \"],[10,0],[14,0,\"warning\"],[12],[1,\"\\n          \"],[1,[28,[35,18],[\"exclamation-triangle\"],null]],[1,\"\\n          \"],[1,[28,[35,5],[\"explorer.others_dirty\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"\\n\"],[41,[33,19,[\"length\"]],[[[41,[51,[33,20,[\"fake\"]]],[[[1,\"        \"],[10,0],[15,0,[29,[\"query-edit \",[52,[33,21],\"editing\"]]]],[12],[1,\"\\n\"],[41,[33,20],[[[41,[33,22],[[[1,\"              \"],[10,0],[14,0,\"name\"],[12],[1,\"\\n                \"],[1,[28,[35,10],null,[[\"action\",\"icon\",\"class\"],[[28,[37,11],[[30,0],\"goHome\"],null],\"chevron-left\",\"previous\"]]]],[1,\"\\n                \"],[10,0],[14,0,\"name-text-field\"],[12],[1,\"\\n                  \"],[1,[28,[35,8],null,[[\"value\"],[[33,20,[\"name\"]]]]]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\\n              \"],[10,0],[14,0,\"desc\"],[12],[1,\"\\n                \"],[1,[28,[35,23],null,[[\"value\",\"placeholder\"],[[33,20,[\"description\"]],[28,[37,5],[\"explorer.description_placeholder\"],null]]]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[1,\"              \"],[10,0],[14,0,\"name\"],[12],[1,\"\\n                \"],[1,[28,[35,10],null,[[\"action\",\"icon\",\"class\"],[[28,[37,11],[[30,0],\"goHome\"],null],\"chevron-left\",\"previous\"]]]],[1,\"\\n\\n                \"],[10,\"h1\"],[12],[1,\"\\n                  \"],[1,[33,20,[\"name\"]]],[1,\"\\n\"],[41,[51,[33,24]],[[[1,\"                    \"],[11,3],[24,6,\"\"],[4,[38,11],[[30,0],\"editName\"],[[\"class\"],[\"edit-query-name\"]]],[12],[1,\"\\n                      \"],[1,[28,[35,18],[\"pencil-alt\"],null]],[1,\"\\n                    \"],[13],[1,\"\\n\"]],[]],null],[1,\"                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\\n              \"],[10,0],[14,0,\"desc\"],[12],[1,\"\\n                \"],[1,[33,20,[\"description\"]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]]],[1,\"\\n            \"],[10,0],[14,0,\"pull-left\"],[12],[1,\"\\n              \"],[10,0],[14,0,\"groups\"],[12],[1,\"\\n                \"],[10,1],[14,0,\"label\"],[12],[1,[28,[35,5],[\"explorer.allow_groups\"],null]],[13],[1,\"\\n                \"],[10,1],[12],[1,\"\\n                  \"],[1,[28,[35,25],null,[[\"value\",\"content\",\"allowAny\",\"onSelect\"],[[33,20,[\"group_ids\"]],[33,26],false,[28,[37,11],[[30,0],[28,[37,27],[[33,20,[\"group_ids\"]]],null]],null]]]]],[1,\"\\n                \"],[13],[1,\"\\n\\n\"],[41,[33,28],[[[41,[51,[33,22]],[[[1,\"                    \"],[10,1],[14,0,\"setting-controls\"],[12],[1,\"\\n                      \"],[1,[28,[35,10],null,[[\"class\",\"action\",\"icon\"],[\"ok\",[28,[37,11],[[30,0],\"save\"],null],\"check\"]]]],[1,\"\\n                      \"],[1,[28,[35,10],null,[[\"class\",\"action\",\"icon\"],[\"cancel\",[28,[37,11],[[30,0],\"discard\"],null],\"times\"]]]],[1,\"\\n                    \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\\n            \"],[10,0],[14,0,\"clear\"],[12],[13],[1,\"\\n\\n\"],[41,[33,2],[[[1,\"              \"],[10,0],[15,0,[29,[\"query-editor \",[52,[33,1],\"no-schema\"]]]],[12],[1,\"\\n                \"],[10,0],[14,0,\"panels-flex\"],[12],[1,\"\\n                  \"],[10,0],[14,0,\"editor-panel\"],[12],[1,\"\\n                    \"],[1,[28,[35,29],null,[[\"content\",\"mode\"],[[33,20,[\"sql\"]],\"sql\"]]]],[1,\"\\n                  \"],[13],[1,\"\\n\\n                  \"],[10,0],[14,0,\"right-panel\"],[12],[1,\"\\n\"],[41,[33,1],[[[1,\"                      \"],[1,[28,[35,10],null,[[\"action\",\"icon\",\"class\"],[[28,[37,11],[[30,0],\"expandSchema\"],null],\"chevron-left\",\"no-text unhide\"]]]],[1,\"\\n\"]],[]],null],[1,\"\\n                    \"],[10,0],[14,0,\"schema\"],[12],[1,\"\\n                      \"],[1,[28,[35,30],null,[[\"schema\",\"hideSchema\"],[[33,31],[33,1]]]]],[1,\"\\n                    \"],[13],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n\\n                \"],[10,0],[14,0,\"grippie\"],[12],[1,\"\\n                  \"],[1,[28,[35,18],[\"discourse-expand\"],null]],[1,\"\\n                \"],[13],[1,\"\\n\\n                \"],[10,0],[14,0,\"clear\"],[12],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[1,\"              \"],[10,0],[14,0,\"sql\"],[12],[1,\"\\n                \"],[1,[28,[35,32],null,[[\"value\",\"codeClass\"],[[33,20,[\"sql\"]],\"sql\"]]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]]],[1,\"\\n            \"],[10,0],[14,0,\"clear\"],[12],[13],[1,\"\\n\\n            \"],[10,0],[14,0,\"pull-left left-buttons\"],[12],[1,\"\\n\"],[41,[33,2],[[[1,\"                \"],[1,[28,[35,10],null,[[\"action\",\"label\",\"disabled\"],[[28,[37,11],[[30,0],\"save\"],null],\"explorer.save\",[33,33]]]]],[1,\"\\n\"]],[]],[[[41,[51,[33,24]],[[[1,\"                  \"],[1,[28,[35,10],null,[[\"action\",\"label\",\"icon\"],[[28,[37,11],[[30,0],\"editName\"],null],\"explorer.edit\",\"pencil-alt\"]]]],[1,\"\\n\"]],[]],null]],[]]],[1,\"\\n              \"],[1,[28,[35,10],null,[[\"action\",\"label\",\"disabled\",\"icon\"],[[28,[37,11],[[30,0],\"download\"],null],\"explorer.export\",[33,28],\"download\"]]]],[1,\"\\n\\n\"],[41,[33,2],[[[1,\"                \"],[1,[28,[35,10],null,[[\"action\",\"label\",\"icon\"],[[28,[37,11],[[30,0],\"showHelpModal\"],null],\"explorer.help.label\",\"question-circle\"]]]],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n\\n            \"],[10,0],[14,0,\"pull-right right-buttons\"],[12],[1,\"\\n\"],[41,[33,20,[\"destroyed\"]],[[[1,\"                \"],[1,[28,[35,10],null,[[\"action\",\"class\",\"icon\",\"label\"],[[28,[37,11],[[30,0],\"recover\"],null],\"\",\"undo\",\"explorer.recover\"]]]],[1,\"\\n\"]],[]],[[[41,[33,2],[[[1,\"                  \"],[1,[28,[35,10],null,[[\"action\",\"icon\",\"label\",\"disabled\"],[[28,[37,11],[[30,0],\"discard\"],null],\"undo\",\"explorer.undo\",[33,34]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n                \"],[1,[28,[35,10],null,[[\"action\",\"class\",\"icon\",\"label\"],[[28,[37,11],[[30,0],\"destroy\"],null],\"btn-danger\",\"trash-alt\",\"explorer.delete\"]]]],[1,\"\\n\"]],[]]],[1,\"            \"],[13],[1,\"\\n\\n            \"],[10,0],[14,0,\"clear\"],[12],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\\n        \"],[11,\"form\"],[24,0,\"query-run\"],[4,[38,11],[[30,0],\"run\"],[[\"on\"],[\"submit\"]]],[12],[1,\"\\n\"],[41,[33,20,[\"hasParams\"]],[[[1,\"            \"],[10,0],[14,0,\"query-params\"],[12],[1,\"\\n\"],[42,[28,[37,36],[[28,[37,36],[[33,20,[\"param_info\"]]],null]],null],null,[[[1,\"                \"],[1,[28,[35,37],null,[[\"params\",\"initialValues\",\"info\"],[[33,20,[\"params\"]],[33,38],[30,1]]]]],[1,\"\\n\"]],[1]],null],[1,\"            \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[33,28],[[[41,[33,34],[[[1,\"              \"],[1,[28,[35,10],null,[[\"label\",\"disabled\",\"class\"],[\"explorer.run\",\"true\",\"btn-primary\"]]]],[1,\"\\n\"]],[]],[[[1,\"              \"],[1,[28,[35,10],null,[[\"action\",\"icon\",\"label\",\"class\"],[[28,[37,11],[[30,0],\"saverun\"],null],\"play\",\"explorer.saverun\",\"btn-primary\"]]]],[1,\"\\n\"]],[]]]],[]],[[[1,\"            \"],[1,[28,[35,10],null,[[\"action\",\"icon\",\"label\",\"disabled\",\"class\",\"type\"],[[28,[37,11],[[30,0],\"run\"],null],\"play\",\"explorer.run\",[33,28],\"btn-primary\",\"submit\"]]]],[1,\"\\n\"]],[]]],[1,\"\\n          \"],[10,\"label\"],[14,0,\"query-plan\"],[12],[1,\"\\n            \"],[1,[28,[35,39],null,[[\"type\",\"checked\",\"name\"],[\"checkbox\",[33,40],\"explain\"]]]],[1,\"\\n            \"],[1,[28,[35,5],[\"explorer.explain_label\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[10,\"hr\"],[12],[13],[1,\"\\n\"]],[]],null],[1,\"\\n      \"],[1,[28,[35,41],null,[[\"condition\"],[[33,42]]]]],[1,\"\\n\\n\"],[41,[51,[33,20,[\"fake\"]]],[[[41,[33,43],[[[1,\"          \"],[10,0],[14,0,\"query-results\"],[12],[1,\"\\n\"],[41,[33,44],[[[1,\"              \"],[1,[28,[35,45],null,[[\"query\",\"content\"],[[33,20],[33,43]]]]],[1,\"\\n\"]],[]],[[[42,[28,[37,36],[[28,[37,36],[[33,43,[\"errors\"]]],null]],null],null,[[[1,\"                \"],[10,\"pre\"],[14,0,\"query-error\"],[12],[10,\"code\"],[12],[1,[30,2]],[13],[13],[1,\"\\n\"]],[2]],null]],[]]],[1,\"          \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"\\n\"],[41,[33,46],[[[1,\"        \"],[10,0],[14,0,\"container\"],[12],[1,\"\\n          \"],[10,\"table\"],[14,0,\"recent-queries\"],[12],[1,\"\\n            \"],[10,\"thead\"],[14,0,\"heading-container\"],[12],[1,\"\\n              \"],[10,\"th\"],[14,0,\"col heading name\"],[12],[1,\"\\n                \"],[11,0],[24,\"role\",\"button\"],[24,0,\"heading-toggle\"],[4,[38,11],[[30,0],\"sortByProperty\",\"name\"],null],[12],[1,\"\\n                  \"],[1,[28,[35,47],null,[[\"field\",\"labelKey\",\"order\",\"asc\",\"automatic\"],[\"name\",\"explorer.query_name\",[33,48],[33,49],true]]]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,\"th\"],[14,0,\"col heading created-by\"],[12],[1,\"\\n                \"],[11,0],[24,\"role\",\"button\"],[24,0,\"heading-toggle\"],[4,[38,11],[[30,0],\"sortByProperty\",\"username\"],null],[12],[1,\"\\n                  \"],[1,[28,[35,47],null,[[\"field\",\"labelKey\",\"order\",\"asc\",\"automatic\"],[\"username\",\"explorer.query_user\",[33,48],[33,49],true]]]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,\"th\"],[14,0,\"col heading group-names\"],[12],[1,\"\\n                \"],[10,0],[14,0,\"group-names-header\"],[12],[1,\"\\n                  \"],[1,[28,[35,5],[\"explorer.query_groups\"],null]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,\"th\"],[14,0,\"col heading created-at\"],[12],[1,\"\\n                \"],[11,0],[24,\"role\",\"button\"],[24,0,\"heading-toggle\"],[4,[38,11],[[30,0],\"sortByProperty\",\"last_run_at\"],null],[12],[1,\"\\n                  \"],[1,[28,[35,47],null,[[\"field\",\"labelKey\",\"order\",\"asc\",\"automatic\"],[\"last_run_at\",\"explorer.query_time\",[33,48],[33,49],true]]]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,36],[[28,[37,36],[[33,50]],null]],null],null,[[[1,\"                \"],[10,\"tr\"],[14,0,\"query-row\"],[12],[1,\"\\n                  \"],[10,\"td\"],[12],[1,\"\\n                    \"],[11,3],[16,6,[29,[\"/admin/plugins/explorer/?id=\",[30,3,[\"id\"]]]]],[4,[38,11],[[30,0],\"scrollTop\"],null],[12],[1,\"\\n                      \"],[10,\"b\"],[14,0,\"query-name\"],[12],[1,[30,3,[\"name\"]]],[13],[1,\"\\n                      \"],[10,\"medium\"],[14,0,\"query-desc\"],[12],[1,[30,3,[\"description\"]]],[13],[1,\"\\n                    \"],[13],[1,\"\\n                  \"],[13],[1,\"\\n                  \"],[10,\"td\"],[14,0,\"query-created-by\"],[12],[1,\"\\n\"],[41,[30,3,[\"username\"]],[[[1,\"                      \"],[10,3],[15,6,[29,[\"/u/\",[30,3,[\"username\"]],\"/activity\"]]],[12],[1,\"\\n                        \"],[10,\"medium\"],[12],[1,[30,3,[\"username\"]]],[13],[1,\"\\n                      \"],[13],[1,\"\\n\"]],[]],null],[1,\"                  \"],[13],[1,\"\\n                  \"],[10,\"td\"],[14,0,\"query-group-names\"],[12],[1,\"\\n\"],[42,[28,[37,36],[[28,[37,36],[[30,3,[\"group_names\"]]],null]],null],null,[[[1,\"                      \"],[1,[28,[35,51],null,[[\"group\",\"query\"],[[30,4],[30,3]]]]],[1,\"\\n\"]],[4]],null],[1,\"                  \"],[13],[1,\"\\n                  \"],[10,\"td\"],[14,0,\"query-created-at\"],[12],[1,\"\\n\"],[41,[30,3,[\"last_run_at\"]],[[[1,\"                      \"],[10,\"medium\"],[12],[1,\"\\n                        \"],[1,[28,[35,52],[[30,3,[\"last_run_at\"]]],null]],[1,\"\\n                      \"],[13],[1,\"\\n\"]],[]],[[[41,[30,3,[\"created_at\"]],[[[1,\"                      \"],[10,\"medium\"],[12],[1,\"\\n                        \"],[1,[28,[35,52],[[30,3,[\"created_at\"]]],null]],[1,\"\\n                      \"],[13],[1,\"\\n                    \"]],[]],null]],[]]],[1,\"                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n\"]],[3]],[[[1,\"                \"],[10,\"br\"],[12],[13],[1,\"\\n                \"],[10,\"em\"],[14,0,\"no-search-results\"],[12],[1,\"\\n                  \"],[1,[28,[35,5],[\"explorer.no_search_results\"],null]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]]],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n      \"],[10,0],[14,0,\"explorer-pad-bottom\"],[12],[13],[1,\"\\n\"]],[]],null]],[]]]],[]]]]]],[\"pinfo\",\"err\",\"query\",\"group\"],false,[\"explorer-container\",\"hideSchema\",\"everEditing\",\"if\",\"disallow\",\"i18n\",\"unless\",\"selectedQueryId\",\"text-field\",\"search\",\"d-button\",\"action\",\"pick-files-button\",\"acceptedImportFileTypes\",\"showCreate\",\"newQueryName\",\"createDisabled\",\"othersDirty\",\"d-icon\",\"model\",\"selectedItem\",\"editName\",\"editing\",\"textarea\",\"editDisabled\",\"multi-select\",\"groupOptions\",\"mut\",\"runDisabled\",\"ace-editor\",\"explorer-schema\",\"schema\",\"hljs-code-view\",\"saveDisable\",\"saveDisabled\",\"each\",\"-track-array\",\"param-input\",\"parsedParams\",\"input\",\"explain\",\"conditional-loading-spinner\",\"loading\",\"results\",\"showResults\",\"query-result\",\"showRecentQueries\",\"table-header-toggle\",\"order\",\"asc\",\"filteredContent\",\"share-report\",\"bound-date\"]]","moduleName":"javascripts/discourse/templates/admin/plugins-explorer","isStrictMode":false});
Ember.TEMPLATES["javascripts/components/data-explorer-bar-chart"] = Ember.HTMLBars.template({"id":null,"block":"[[[10,\"canvas\"],[12],[13],[1,\"\\n\"]],[],false,[]]","moduleName":"javascripts/discourse/templates/components/data-explorer-bar-chart","isStrictMode":false});
Ember.TEMPLATES["javascripts/components/explorer-schema-enuminfo"] = Ember.HTMLBars.template({"id":null,"block":"[[[42,[28,[37,1],[[28,[37,1],[[33,2]],null]],null],null,[[[1,\"  \"],[10,\"li\"],[15,2,[30,1,[\"value\"]]],[12],[1,\"\\n    \"],[1,[30,1,[\"name\"]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[1]],null]],[\"enum\"],false,[\"each\",\"-track-array\",\"enuminfo\"]]","moduleName":"javascripts/discourse/templates/components/explorer-schema-enuminfo","isStrictMode":false});
Ember.TEMPLATES["javascripts/components/explorer-schema-onetable"] = Ember.HTMLBars.template({"id":null,"block":"[[[10,0],[14,0,\"schema-table-name\"],[12],[1,\"\\n\"],[41,[33,1],[[[1,\"    \"],[1,[28,[35,2],[\"caret-down\"],null]],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,2],[\"caret-right\"],null]],[1,\"\\n\"]],[]]],[1,\"  \"],[1,[33,3,[\"name\"]]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"schema-table-cols\"],[12],[1,\"\\n\"],[41,[33,1],[[[1,\"    \"],[10,\"dl\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[33,3,[\"columns\"]]],null]],null],null,[[[1,\"        \"],[10,0],[12],[1,\"\\n          \"],[10,\"dt\"],[15,0,[52,[30,1,[\"sensitive\"]],\"sensitive\"]],[15,\"title\",[52,[30,1,[\"sensitive\"]],[28,[37,6],[\"explorer.schema.sensitive\"],null]]],[12],[1,\"\\n\"],[41,[30,1,[\"sensitive\"]],[[[1,\"              \"],[1,[28,[35,2],[\"exclamation-triangle\"],null]],[1,\"\\n\"]],[]],null],[1,\"            \"],[1,[30,1,[\"column_name\"]]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"dd\"],[12],[1,\"\\n            \"],[1,[30,1,[\"data_type\"]]],[1,\"\\n\"],[41,[30,1,[\"havetypeinfo\"]],[[[1,\"              \"],[10,\"br\"],[12],[13],[1,\"\\n\"],[41,[30,1,[\"havepopup\"]],[[[1,\"                \"],[10,0],[14,0,\"popup-info\"],[12],[1,\"\\n                  \"],[1,[28,[35,2],[\"info\"],null]],[1,\"\\n                  \"],[10,0],[14,0,\"popup\"],[12],[1,\"\\n                    \"],[1,[30,1,[\"column_desc\"]]],[1,\"\\n\"],[41,[30,1,[\"enum\"]],[[[1,\"                      \"],[1,[28,[35,7],null,[[\"col\"],[[30,1]]]]],[1,\"\\n\"]],[]],null],[1,\"                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],null],[1,\"              \"],[10,1],[14,0,\"schema-typenotes\"],[12],[1,\"\\n                \"],[1,[30,1,[\"notes\"]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[1]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\"]],[\"col\"],false,[\"if\",\"open\",\"d-icon\",\"table\",\"each\",\"-track-array\",\"i18n\",\"explorer-schema-enuminfo\"]]","moduleName":"javascripts/discourse/templates/components/explorer-schema-onetable","isStrictMode":false});
Ember.TEMPLATES["javascripts/components/explorer-schema"] = Ember.HTMLBars.template({"id":null,"block":"[[[10,0],[15,0,[52,[33,1],\"hidden\"]],[12],[1,\"\\n  \"],[10,0],[14,0,\"schema-search inline-form full-width\"],[12],[1,\"\\n    \"],[1,[28,[35,2],null,[[\"value\",\"placeholderKey\"],[[33,3],\"explorer.schema.filter\"]]]],[1,\"\\n    \"],[1,[28,[35,4],null,[[\"action\",\"icon\",\"class\"],[[28,[37,5],[[30,0],\"collapseSchema\"],null],\"chevron-right\",\"no-text\"]]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[1,[28,[35,6],null,[[\"condition\"],[[33,7]]]]],[1,\"\\n\\n  \"],[10,0],[14,0,\"schema-container\"],[12],[1,\"\\n    \"],[10,\"ul\"],[12],[1,\"\\n\"],[42,[28,[37,9],[[28,[37,9],[[33,10]],null]],null],null,[[[1,\"        \"],[1,[28,[35,11],null,[[\"table\"],[[30,1]]]]],[1,\"\\n\"]],[1]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"table\"],false,[\"if\",\"hideSchema\",\"text-field\",\"filter\",\"d-button\",\"action\",\"conditional-loading-spinner\",\"loading\",\"each\",\"-track-array\",\"filteredTables\",\"explorer-schema-onetable\"]]","moduleName":"javascripts/discourse/templates/components/explorer-schema","isStrictMode":false});
Ember.TEMPLATES["javascripts/components/hljs-code-view"] = Ember.HTMLBars.template({"id":null,"block":"[[[10,\"pre\"],[12],[10,\"code\"],[15,0,[36,0]],[12],[1,[34,1]],[13],[13],[1,\"\\n\"]],[],false,[\"codeClass\",\"value\"]]","moduleName":"javascripts/discourse/templates/components/hljs-code-view","isStrictMode":false});
Ember.TEMPLATES["javascripts/components/query-row-content"] = Ember.HTMLBars.template({"id":null,"block":"[[[1,[34,0]],[1,\"\\n\"]],[],false,[\"rowContents\"]]","moduleName":"javascripts/discourse/templates/components/query-row-content","isStrictMode":false});
Ember.TEMPLATES["javascripts/components/share-report"] = Ember.HTMLBars.template({"id":null,"block":"[[[10,0],[14,\"role\",\"button\"],[15,\"onclick\",[28,[37,0],[[30,0],\"open\"],null]],[12],[1,\"\\n  \"],[1,[28,[35,1],[\"link\"],null]],[1,\"\\n  \"],[1,[34,2]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[33,4],[[[1,\"  \"],[10,0],[14,0,\"popup\"],[12],[1,\"\\n    \"],[10,\"label\"],[12],[1,[28,[35,5],[\"explorer.link\"],null]],[1,\" \"],[1,[34,2]],[13],[1,\"\\n    \"],[10,\"input\"],[15,2,[36,6]],[14,4,\"text\"],[12],[13],[1,\"\\n\\n    \"],[1,[28,[35,7],null,[[\"action\",\"class\",\"icon\",\"aria-label\",\"title\"],[\"close\",\"btn-flat close\",\"times\",\"share.close\",\"share.close\"]]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[],false,[\"action\",\"d-icon\",\"group\",\"if\",\"visible\",\"i18n\",\"link\",\"d-button\"]]","moduleName":"javascripts/discourse/templates/components/share-report","isStrictMode":false});
Ember.TEMPLATES["javascripts/connectors/group-reports-nav-item/nav-item"] = Ember.HTMLBars.template({"id":null,"block":"[[[6,[39,0],null,[[\"route\"],[\"group.reports\"]],[[\"default\"],[[[[1,\"  \"],[1,[28,[35,1],[\"chart-bar\"],null]],[1,[28,[35,2],[\"group.reports\"],null]],[1,\"\\n\"]],[]]]]]],[],false,[\"link-to\",\"d-icon\",\"i18n\"]]","moduleName":"javascripts/discourse/templates/connectors/group-reports-nav-item/nav-item","isStrictMode":false});
Ember.TEMPLATES["javascripts/explorer-query-result"] = Ember.HTMLBars.template({"id":null,"block":"[[[10,\"article\"],[12],[1,\"\\n  \"],[10,\"header\"],[14,0,\"result-header\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"result-info\"],[12],[1,\"\\n      \"],[1,[28,[35,0],null,[[\"action\",\"icon\",\"label\",\"group\"],[[28,[37,1],[[30,0],\"downloadResultJson\"],null],\"download\",\"explorer.download_json\",[33,2]]]]],[1,\"\\n\\n      \"],[1,[28,[35,0],null,[[\"action\",\"icon\",\"label\",\"group\"],[[28,[37,1],[[30,0],\"downloadResultCsv\"],null],\"download\",\"explorer.download_csv\",[33,2]]]]],[1,\"\\n\\n\"],[41,[33,4],[[[41,[33,5],[[[1,\"          \"],[1,[28,[35,0],null,[[\"action\",\"icon\",\"label\",\"group\"],[[28,[37,1],[[30,0],\"showTable\"],null],\"table\",\"explorer.show_table\",[33,2]]]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,0],null,[[\"action\",\"icon\",\"label\",\"group\"],[[28,[37,1],[[30,0],\"showChart\"],null],\"chart-bar\",\"explorer.show_graph\",[33,2]]]]],[1,\"\\n\"]],[]]]],[]],null],[1,\"    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"result-about\"],[12],[1,\"\\n      \"],[1,[34,6]],[1,\"\\n      \"],[1,[34,7]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,\"br\"],[12],[13],[41,[33,8],[[[1,\"      \"],[10,\"pre\"],[14,0,\"result-explain\"],[12],[10,\"code\"],[12],[1,[33,9,[\"explain\"]]],[1,\"\\n        \"],[13],[13]],[]],null],[1,\"\\n    \"],[10,\"br\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,\"section\"],[12],[1,\"\\n\"],[41,[33,5],[[[1,\"      \"],[1,[28,[35,10],null,[[\"labels\",\"values\",\"datasetName\"],[[33,11],[33,12],[33,13]]]]],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,\"table\"],[12],[1,\"\\n        \"],[10,\"thead\"],[12],[1,\"\\n          \"],[10,\"tr\"],[14,0,\"headers\"],[12],[1,\"\\n\"],[42,[28,[37,15],[[28,[37,15],[[33,16]],null]],null],null,[[[1,\"              \"],[10,\"th\"],[12],[1,[30,1]],[13],[1,\"\\n\"]],[1]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,15],[[28,[37,15],[[33,17]],null]],null],null,[[[1,\"            \"],[1,[28,[35,18],null,[[\"row\",\"fallbackTemplate\",\"columnTemplates\"],[[30,2],[33,19],[33,20]]]]],[1,\"\\n\"]],[2]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"col\",\"row\"],false,[\"d-button\",\"action\",\"group\",\"if\",\"canShowChart\",\"showChart\",\"resultCount\",\"duration\",\"hasExplain\",\"content\",\"data-explorer-bar-chart\",\"chartLabels\",\"chartValues\",\"chartDatasetName\",\"each\",\"-track-array\",\"columnDispNames\",\"rows\",\"query-row-content\",\"fallbackTemplate\",\"columnTemplates\"]]","moduleName":"javascripts/discourse/templates/explorer-query-result","isStrictMode":false});
var __t = requirejs('discourse-common/lib/raw-handlebars').template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a\n  href=\""
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"baseuri",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":3,"column":19}}}))
    + "/badges/"
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"badge.id",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":3,"column":27},"end":{"line":3,"column":39}}}))
    + "/"
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"badge.name",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":3,"column":40},"end":{"line":3,"column":54}}}))
    + "\"\n  class=\"user-badge "
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"badge.badgeTypeClassName",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":4,"column":20},"end":{"line":4,"column":48}}}))
    + "\"\n  title="
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"badge.display_name",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":5,"column":8},"end":{"line":5,"column":30}}}))
    + "\n  data-badge-name="
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"badge.name",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":6,"column":18},"end":{"line":6,"column":32}}}))
    + "\n>\n  "
    + container.escapeExpression((lookupProperty(helpers,"icon-or-image")||(depth0 && lookupProperty(depth0,"icon-or-image"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"badge.icon",{"name":"icon-or-image","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":8,"column":2},"end":{"line":8,"column":30}}}))
    + "\n  <span class=\"badge-display-name\">"
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"badge.display_name",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":9,"column":35},"end":{"line":9,"column":57}}}))
    + "</span>\n</a>\n";
},"useData":true});;
requirejs('discourse-common/lib/raw-templates').addRawTemplate("javascripts/explorer/badge", __t);
var __t = requirejs('discourse-common/lib/raw-handlebars').template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  "
    + container.escapeExpression((lookupProperty(helpers,"category-link")||(depth0 && lookupProperty(depth0,"category-link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"category",{"name":"category-link","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":2,"column":28}}}))
    + "\n";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <a href=\""
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"baseuri",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":4,"column":11},"end":{"line":4,"column":22}}}))
    + "/t/"
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"id",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":4,"column":25},"end":{"line":4,"column":31}}}))
    + "\">"
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"id",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":4,"column":33},"end":{"line":4,"column":39}}}))
    + "</a>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),"category",{"name":"if","hash":{},"hashTypes":{},"hashContexts":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":7}}})) != null ? stack1 : "");
},"useData":true});;
requirejs('discourse-common/lib/raw-templates').addRawTemplate("javascripts/explorer/category", __t);
var __t = requirejs('discourse-common/lib/raw-handlebars').template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <a href=\""
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"baseuri",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":2,"column":11},"end":{"line":2,"column":22}}}))
    + "/groups/"
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"group.name",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":2,"column":30},"end":{"line":2,"column":44}}}))
    + "\">"
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"group.name",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":2,"column":46},"end":{"line":2,"column":60}}}))
    + "</a>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  "
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"id",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":4,"column":2},"end":{"line":4,"column":8}}}))
    + "\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),"group",{"name":"if","hash":{},"hashTypes":{},"hashContexts":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":7}}})) != null ? stack1 : "");
},"useData":true});;
requirejs('discourse-common/lib/raw-templates').addRawTemplate("javascripts/explorer/group", __t);
var __t = requirejs('discourse-common/lib/raw-handlebars').template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression((lookupProperty(helpers,"html-safe")||(depth0 && lookupProperty(depth0,"html-safe"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"value",{"name":"html-safe","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":19}}}))
    + "\n";
},"useData":true});;
requirejs('discourse-common/lib/raw-templates').addRawTemplate("javascripts/explorer/html", __t);
var __t = requirejs('discourse-common/lib/raw-handlebars').template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <aside\n    class=\"quote\"\n    data-post="
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"post.post_number",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":4,"column":14},"end":{"line":4,"column":34}}}))
    + "\n    data-topic="
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"post.topic_id",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":5,"column":15},"end":{"line":5,"column":32}}}))
    + "\n  >\n    <div class=\"title\">\n      <div class=\"quote-controls\">\n        <a\n          href=\"/t/via-quote/"
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"post.topic_id",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":11,"column":29},"end":{"line":11,"column":46}}}))
    + "/"
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"post.post_number",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":11,"column":47},"end":{"line":11,"column":67}}}))
    + "\"\n          title=\"go to the quoted post\"\n          class=\"quote-other-topic\"\n        >\n        </a>\n      </div>\n\n      <a\n        class=\"result-post-link\"\n        href=\"/t/"
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"post.topic_id",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":20,"column":17},"end":{"line":20,"column":34}}}))
    + "/"
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"post.post_number",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":20,"column":35},"end":{"line":20,"column":55}}}))
    + "\"\n      >\n        "
    + container.escapeExpression((lookupProperty(helpers,"avatar")||(depth0 && lookupProperty(depth0,"avatar"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"post",{"name":"avatar","hash":{"imageSize":"tiny"},"hashTypes":{"imageSize":"StringLiteral"},"hashContexts":{"imageSize":depth0},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":22,"column":8},"end":{"line":22,"column":40}}}))
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"post.username",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":22,"column":40},"end":{"line":22,"column":57}}}))
    + ":\n      </a>\n    </div>\n\n    <blockquote>\n      <p>\n        "
    + container.escapeExpression((lookupProperty(helpers,"html-safe")||(depth0 && lookupProperty(depth0,"html-safe"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"post.excerpt",{"name":"html-safe","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":28,"column":8},"end":{"line":28,"column":34}}}))
    + "\n      </p>\n    </blockquote>\n  </aside>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  "
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"id",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":33,"column":2},"end":{"line":33,"column":8}}}))
    + "\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),"post",{"name":"if","hash":{},"hashTypes":{},"hashContexts":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":34,"column":7}}})) != null ? stack1 : "");
},"useData":true});;
requirejs('discourse-common/lib/raw-templates').addRawTemplate("javascripts/explorer/post", __t);
var __t = requirejs('discourse-common/lib/raw-handlebars').template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression((lookupProperty(helpers,"reltime")||(depth0 && lookupProperty(depth0,"reltime"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"value",{"name":"reltime","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":17}}}))
    + "\n";
},"useData":true});;
requirejs('discourse-common/lib/raw-templates').addRawTemplate("javascripts/explorer/reltime", __t);
var __t = requirejs('discourse-common/lib/raw-handlebars').template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"value",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":9}}}))
    + "\n";
},"useData":true});;
requirejs('discourse-common/lib/raw-templates').addRawTemplate("javascripts/explorer/text", __t);
var __t = requirejs('discourse-common/lib/raw-handlebars').template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <a href=\""
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"baseuri",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":2,"column":11},"end":{"line":2,"column":22}}}))
    + "/t/"
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"topic.slug",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":2,"column":25},"end":{"line":2,"column":39}}}))
    + "/"
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"topic.id",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":2,"column":40},"end":{"line":2,"column":52}}}))
    + "\">\n    "
    + container.escapeExpression((lookupProperty(helpers,"html-safe")||(depth0 && lookupProperty(depth0,"html-safe"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"topic.fancy_title",{"name":"html-safe","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":3,"column":35}}}))
    + "\n  </a>\n  ("
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"topic.posts_count",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":5,"column":3},"end":{"line":5,"column":24}}}))
    + ")\n";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <a href=\""
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"baseuri",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":7,"column":11},"end":{"line":7,"column":22}}}))
    + "/t/"
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"id",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":7,"column":25},"end":{"line":7,"column":31}}}))
    + "\">"
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"id",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":7,"column":33},"end":{"line":7,"column":39}}}))
    + "</a>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),"topic",{"name":"if","hash":{},"hashTypes":{},"hashContexts":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":8,"column":7}}})) != null ? stack1 : "");
},"useData":true});;
requirejs('discourse-common/lib/raw-templates').addRawTemplate("javascripts/explorer/topic", __t);
var __t = requirejs('discourse-common/lib/raw-handlebars').template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a href="
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"href",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":1,"column":8},"end":{"line":1,"column":16}}}))
    + ">"
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"target",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":1,"column":17},"end":{"line":1,"column":27}}}))
    + "</a>\n";
},"useData":true});;
requirejs('discourse-common/lib/raw-templates').addRawTemplate("javascripts/explorer/url", __t);
var __t = requirejs('discourse-common/lib/raw-handlebars').template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <a\n    href=\""
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"baseuri",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":3,"column":10},"end":{"line":3,"column":21}}}))
    + "/u/"
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"user.username",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":3,"column":24},"end":{"line":3,"column":41}}}))
    + "/activity\"\n    data-user-card="
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"user.username",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":4,"column":19},"end":{"line":4,"column":36}}}))
    + "\n  >\n    "
    + container.escapeExpression((lookupProperty(helpers,"avatar")||(depth0 && lookupProperty(depth0,"avatar"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"user",{"name":"avatar","hash":{"imageSize":"tiny"},"hashTypes":{"imageSize":"StringLiteral"},"hashContexts":{"imageSize":depth0},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":6,"column":4},"end":{"line":6,"column":36}}}))
    + "\n    "
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"user.username",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":7,"column":4},"end":{"line":7,"column":21}}}))
    + "\n  </a>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  "
    + container.escapeExpression(lookupProperty(helpers,"get").call(depth0 != null ? depth0 : (container.nullContext || {}),"id",{"name":"get","hash":{},"hashTypes":{},"hashContexts":{},"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":10,"column":2},"end":{"line":10,"column":8}}}))
    + "\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),"user",{"name":"if","hash":{},"hashTypes":{},"hashContexts":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"types":["PathExpression"],"contexts":[depth0],"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":11,"column":7}}})) != null ? stack1 : "");
},"useData":true});;
requirejs('discourse-common/lib/raw-templates').addRawTemplate("javascripts/explorer/user", __t);
Ember.TEMPLATES["javascripts/group-reports-index"] = Ember.HTMLBars.template({"id":null,"block":"[[[10,\"section\"],[14,0,\"user-content\"],[12],[1,\"\\n  \"],[10,\"table\"],[14,0,\"group-reports\"],[12],[1,\"\\n    \"],[10,\"thead\"],[12],[1,\"\\n      \"],[10,\"th\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"explorer.report_name\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"th\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"explorer.query_description\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"th\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"explorer.query_time\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[33,3]],null]],null],null,[[[1,\"        \"],[10,\"tr\"],[12],[1,\"\\n          \"],[10,\"td\"],[12],[1,\"\\n\"],[6,[39,4],null,[[\"route\",\"models\"],[\"group.reports.show\",[28,[37,5],[[33,6,[\"name\"]],[30,1,[\"id\"]]],null]]],[[\"default\"],[[[[1,\"              \"],[1,[30,1,[\"name\"]]],[1,\"\\n\"]],[]]]]],[1,\"          \"],[13],[1,\"\\n          \"],[10,\"td\"],[12],[1,[30,1,[\"description\"]]],[13],[1,\"\\n          \"],[10,\"td\"],[12],[1,\"\\n\"],[41,[30,1,[\"last_run_at\"]],[[[1,\"              \"],[1,[28,[35,8],[[30,1,[\"last_run_at\"]]],null]],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[1]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"query\"],false,[\"i18n\",\"each\",\"-track-array\",\"queries\",\"link-to\",\"array\",\"group\",\"if\",\"bound-date\"]]","moduleName":"javascripts/discourse/templates/group-reports-index","isStrictMode":false});
Ember.TEMPLATES["javascripts/group-reports-show"] = Ember.HTMLBars.template({"id":null,"block":"[[[10,\"section\"],[14,0,\"user-content\"],[12],[1,\"\\n  \"],[10,\"h1\"],[12],[1,[33,0,[\"name\"]]],[13],[1,\"\\n  \"],[10,2],[12],[1,[33,0,[\"description\"]]],[13],[1,\"\\n\\n  \"],[11,\"form\"],[24,0,\"query-run\"],[4,[38,1],[[30,0],\"run\"],[[\"on\"],[\"submit\"]]],[12],[1,\"\\n\"],[41,[33,3],[[[1,\"      \"],[10,0],[14,0,\"query-params\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[33,0,[\"param_info\"]]],null]],null],null,[[[1,\"          \"],[1,[28,[35,6],null,[[\"params\",\"info\"],[[33,0,[\"params\"]],[30,1]]]]],[1,\"\\n\"]],[1]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[1,[28,[35,7],null,[[\"action\",\"icon\",\"label\",\"class\",\"type\"],[[28,[37,1],[[30,0],\"run\"],null],\"play\",\"explorer.run\",\"btn-primary\",\"submit\"]]]],[1,\"\\n\\n    \"],[1,[28,[35,7],null,[[\"action\",\"label\",\"icon\",\"class\"],[[28,[37,1],[[30,0],\"toggleBookmark\"],null],[33,8],[33,9],[33,10]]]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[1,[28,[35,11],null,[[\"condition\"],[[33,12]]]]],[1,\"\\n\\n\"],[41,[33,13],[[[1,\"    \"],[10,0],[14,0,\"query-results\"],[12],[1,\"\\n\"],[41,[33,14],[[[1,\"        \"],[1,[28,[35,15],null,[[\"query\",\"content\",\"group\"],[[33,0],[33,13],[33,16]]]]],[1,\"\\n\"]],[]],[[[42,[28,[37,5],[[28,[37,5],[[33,13,[\"errors\"]]],null]],null],null,[[[1,\"          \"],[10,\"pre\"],[14,0,\"query-error\"],[12],[10,\"code\"],[12],[1,[30,2]],[13],[13],[1,\"\\n\"]],[2]],null]],[]]],[1,\"    \"],[13],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\"]],[\"pinfo\",\"err\"],false,[\"model\",\"action\",\"if\",\"hasParams\",\"each\",\"-track-array\",\"param-input\",\"d-button\",\"bookmarkLabel\",\"bookmarkIcon\",\"bookmarkClassName\",\"conditional-loading-spinner\",\"loading\",\"results\",\"showResults\",\"query-result\",\"group\"]]","moduleName":"javascripts/discourse/templates/group-reports-show","isStrictMode":false});
Ember.TEMPLATES["javascripts/modal/query-help"] = Ember.HTMLBars.template({"id":null,"block":"[[[6,[39,0],null,[[\"title\"],[\"explorer.help.modal_title\"]],[[\"default\"],[[[[1,\"  \"],[1,[28,[35,1],[[28,[37,2],[\"explorer.help.auto_resolution\"],null]],null]],[1,\"\\n  \"],[1,[28,[35,1],[[28,[37,2],[\"explorer.help.custom_params\"],null]],null]],[1,\"\\n  \"],[1,[28,[35,1],[[28,[37,2],[\"explorer.help.default_values\"],null]],null]],[1,\"\\n  \"],[1,[28,[35,1],[[28,[37,2],[\"explorer.help.data_types\"],null]],null]],[1,\"\\n\"]],[]]]]]],[],false,[\"d-modal-body\",\"html-safe\",\"i18n\"]]","moduleName":"javascripts/discourse/templates/modal/query-help","isStrictMode":false});

